import React, { useEffect, useRef, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { ServerPath } from '../../Constant';
// import { uploadImage } from '../../Services/azure-storage-blob';
import { toast } from 'react-toastify';
import axios from 'axios';
import Search from '../../../src/assets/images/svg/search.svg';
import cookieUtils from '../../utils/cookieUtils';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';
import { uploadImage } from '../../Services/r2-storage-blob.js';
import { _axios } from '../../utils/axios.jsx';


// const parseLRCToJSON = (lrcContent) => {
//     const lines = lrcContent.split('\n');
//     const lyricsLines = [];

//     lines.forEach(line => {
//         const match = line.match(/\[(\d{2}):(\d{2})\.(\d{2})\](.*)/);
//         if (match) {
//             const minutes = parseInt(match[1]);
//             const seconds = parseInt(match[2]);
//             const milliseconds = parseInt(match[3]);
//             const time = minutes * 60 + seconds + milliseconds / 100;
//             const text = match[4].trim();

//             if (text) {
//                 lyricsLines.push({ time, text });
//             }
//         }
//     });

//     return { lines: lyricsLines };
// };


// Add this right after your imports
const processHtmlForPreview = (html) => {
    if (!html) return '<p>Your content will appear here...</p>';

    // Create a temporary div to manipulate the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Style all ol elements
    const olElements = tempDiv.querySelectorAll('ol');
    olElements.forEach(ol => {
        ol.style.paddingLeft = '20px';
        ol.style.margin = '10px 0';
        ol.style.listStyleType = 'decimal';
        ol.style.listStylePosition = 'outside';
        ol.style.display = 'block';
    });

    // Style all ul elements
    const ulElements = tempDiv.querySelectorAll('ul');
    ulElements.forEach(ul => {
        ul.style.paddingLeft = '20px';
        ul.style.margin = '10px 0';
        ul.style.listStyleType = 'disc';
        ul.style.listStylePosition = 'outside';
        ul.style.display = 'block';
    });

    // Style all li elements
    const liElements = tempDiv.querySelectorAll('li');
    liElements.forEach(li => {
        li.style.display = 'list-item';
        li.style.margin = '5px 0';
        li.style.lineHeight = '1.6';
        li.style.listStylePosition = 'outside';
    });

    return tempDiv.innerHTML;
};

const CreateLearning = ({ show, onHide }) => {
    // Get all possible cookie data
    const userRole = cookieUtils.getSecureCookie('role');
    const userEmail = cookieUtils.getSecureCookie('email');
    const userData = cookieUtils.getSecureCookie('user');
    const adminId = cookieUtils.getSecureCookie('admin_id');
    const userId = cookieUtils.getSecureCookie('user_id');
    const [htmlContent, setHtmlContent] = useState('');
    const [showPreview, setShowPreview] = useState(false);
    const [hasLyrics, setHasLyrics] = useState(false);
    const [allAuthors, setAllAuthors] = useState([]); // Stores the full fetched list of authors
    const [filteredAuthors, setFilteredAuthors] = useState([]); // Stores authors matching current input
    const [showAuthorSuggestions, setShowAuthorSuggestions] = useState(false); // Controls visibility
    const [authorsError, setAuthorsError] = useState(null);
    const [enabledLanguages, setEnabledLanguages] = useState({
        en: false,  // English enabled by default
        hi: false,
        mr: false,
        gu: false
    });

    const SUPPORTED_LANGUAGES = [
        { code: 'en', name: 'English', field: 'title', descField: 'short_description' },
        { code: 'hi', name: 'Hindi', field: 'title_hin', descField: 'short_description_hin' },
        { code: 'mr', name: 'Marathi', field: 'title_mar', descField: 'short_description_mar' },
        { code: 'gu', name: 'Gujarati', field: 'title_guj', descField: 'short_description_guj' } // or 'short_description_eng' if you keep that naming
    ];

    const [descriptionByLanguage, setDescriptionByLanguage] = useState({
        en: '',
        hi: '',
        mr: '',
        gu: ''
    });
    const [contentByLanguage, setContentByLanguage] = useState({
        en: '',
        hi: '',
        mr: '',
        gu: ''
    });
    const [activeContentTab, setActiveContentTab] = useState('en');
    const [filesByLanguage, setFilesByLanguage] = useState({
        en: { main: null, thumbnail: null },
        hi: { main: null },
        mr: { main: null },
        gu: { main: null }
    });
    const [currentMediaByLanguage, setCurrentMediaByLanguage] = useState({
        en: { main_url: '' },
        hi: { main_url: '' },
        mr: { main_url: '' },
        gu: { main_url: '' }
    });
    const [videoSource, setVideoSource] = useState('UPLOADED');
    const [youtubeUrlByLanguage, setYoutubeUrlByLanguage] = useState({
        en: '',
        hi: '',
        mr: '',
        gu: ''
    });
    const YOUTUBE_URL_REGEX = /^(https?:\/\/)?([\w-]+\.)?(youtube\.com|youtu\.be)\/.+/i;
    // SunEditor configuration
    const sunEditorOptions = {
        buttonList: [
            ['undo', 'redo'],
            ['font', 'fontSize', 'formatBlock'],
            ['bold', 'italic', 'underline', 'strike'],
            ['fontColor', 'hiliteColor'],
            ['align', 'list', 'lineHeight'],
            ['outdent', 'indent'],
            ['link'],
            ['fullScreen'],
            // ['preview']
        ],
        height: 200,
        placeholder: 'Enter your literature content here...',
        resizingBar: false,
        showPathLabel: false,
        charCounter: false,
        maxCharCount: null
    };

    useEffect(() => {
        const fetchAllAuthors = async () => {
            try {
                const url = `${ServerPath}/artifacts/authors/list`; // Your unique authors API endpoint
                const response = await _axios.get(url);

                const fetchedAuthors = response?.data?.data;

                if (response?.data?.success === 1 && Array.isArray(fetchedAuthors)) {
                    setAllAuthors(fetchedAuthors);
                    // Initially, show all authors if the input is empty on focus
                    // or filter if there's already a value
                    setFilteredAuthors(fetchedAuthors.filter(author =>
                        author.toLowerCase().includes(formData.author.toLowerCase())
                    ));
                } else {
                    throw new Error(response?.data?.message || 'Unexpected authors API response format');
                }
            } catch (err) {
                console.error("Error fetching all authors:", err);
                if (axios.isAxiosError(err)) {
                    setAuthorsError(err.response?.data?.message || err.message || "Network or server error fetching authors");
                } else {
                    setAuthorsError(err.message || "An unexpected error occurred while fetching authors");
                }
            }
        };

        fetchAllAuthors();
    }, []);

    // Quill editor configuration
    // const quillModules = {
    //     toolbar: [
    //         [{ 'header': [1, 2, 3, false] }],
    //         ['bold', 'italic', 'underline', 'strike'],
    //         [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    //         [{ 'indent': '-1' }, { 'indent': '+1' }],
    //         ['link'],
    //         [{ 'align': [] }],
    //     ],
    //     clipboard: {
    //         // Force plain text to preserve list structure
    //         matchVisual: false,
    //     }

    // };
    // const quillFormats = [
    //     'header', 'bold', 'italic', 'underline', 'strike',
    //     'list', 'bullet', 'indent', 'link', 'image',
    //     'align', 'color', 'background'
    // ];


    // Debug all cookie data
    console.log('Cookie Data:', {
        role: userRole,
        email: userEmail,
        userData,
        adminId,
        userId
    });

    // Try to get userId from various possible sources
    const currentId = userRole === 'superadmin' ? adminId : userId;
    console.log('Using ID:', currentId);

    // Category mapping object
    const CATEGORY_MAP = {
        // Long Videos and Shorts categories
        'DISCOURSES': 1,
        'SATSANGS_QA': 2,
        'SPIRITUAL_EXPERIENCES': 3,
        'LIFE_WELL_BEING': 4,
        'DIVINE_MOMENTS': 5,
        'GUIDED_PRACTICES': 6,
        'MANTRA_CHANTING': 7,
        'SCRIPTURAL_TEACHINGS': 8,
        'PARIKRAMA_SNIPPETS': 9,

        // Text Literature categories
        'SCRIPTURES': 10,
        'STOTRAS_HYMNS': 11,
        'DIVINE_QUOTES': 12,
        'EBOOKS': 13,
        'REFLECTIONS': 14,
        'HAVAN_VIDHIS': 15,
        'ASTROLOGICAL_FORECASTS': 16,
        'POOJA_VIDHIS': 17,
        'ESSAYS_BLOGS': 18,
        'MANTRAS': 19,  // NEW
        'AARTIS': 20,   // NEW

        // Audio or Orals categories (shifted +2)
        'MANTRAS_CHANTS': 21,
        'STOTRA_RECITATIONS': 22,
        'BHAJANS_KIRTANS': 23,
        'AARTI_DAILY_RITUALS': 24,
        'DISCOURSES_PRAVACHANS': 25,
        'SATSANGS': 26,
        'MEDITATION_GUIDED_PRACTICE': 27,
        'AUDIOBOOKS': 28,
        'ASTROLOGICAL_INSIGHTS': 29
    };

    const initialFormState = {
        title: '',
        title_hin: '',
        title_mar: '',
        title_guj: '',
        description: '',
        description_hin: '',
        description_mar: '',
        description_guj: '',
        artifactType: '',
        status: '',
        category: '',
        relatedWaypoint: '',
        selectedWaypoints: [],
        waypoint_id: null,
        subscriptionType: 'FREE',
        promotions: {
            trending: false,
            byGuruji: false
        },
        is_a_part_of_course: false,
        is_a_part_of_explore: false,
        author: '',
        languages: '',
    };

    const handleContentTypeChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    // Initial files state constant
    const initialFilesState = {
        main: null,
        thumbnail: null,
        lyricsData: null
    };

    const [formData, setFormData] = useState(initialFormState);
    const [files, setFiles] = useState(initialFilesState);
    const [waypointResults, setWaypointResults] = useState([]);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [charCount, setCharCount] = useState(0);
    const authorInputContainerRef = useRef(null);
    const [deityResults, setDeityResults] = useState([]);
    const [selectedDeities, setSelectedDeities] = useState([]);
    const [journeyResults, setJourneyResults] = useState([]);
    const [selectedJourneys, setSelectedJourneys] = useState([]);
    const [searchDeity, setSearchDeity] = useState('');
    const [searchJourney, setSearchJourney] = useState('')
    const [saintResults, setSaintResults] = useState([]);
    const [selectedSaints, setSelectedSaints] = useState([]);
    const [searchSaint, setSearchSaint] = useState('');

    const [projectResults, setProjectResults] = useState([]);
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [searchProject, setSearchProject] = useState('');

    const [hasContainer, setHasContainer] = useState(false);
    const [watchFlag, setWatchFlag] = useState(false);
    const [listenFlag, setListenFlag] = useState(false);
    const [readFlag, setReadFlag] = useState(false);
    const [containerOption, setContainerOption] = useState('EXISTING'); // 'EXISTING' or 'NEW'
    const [allContainers, setAllContainers] = useState([]);
    // const [selectedContainerId, setSelectedContainerId] = useState('');
    const [selectedContainers, setSelectedContainers] = useState([]);
    const [searchContainer, setSearchContainer] = useState('');
    const [allReadArtifacts, setAllReadArtifacts] = useState([]);
    const [allListenArtifacts, setAllListenArtifacts] = useState([]);
    const [allWatchArtifacts, setAllWatchArtifacts] = useState([]);
    const [selectedContainerId, setSelectedContainerId] = useState('');
    const [selectedReadId, setSelectedReadId] = useState('');
    const [selectedReadArtifact, setSelectedReadArtifact] = useState(null);
const [readSearch, setReadSearch] = useState('');
    const [selectedListenId, setSelectedListenId] = useState('');
    const [selectedWatchId, setSelectedWatchId] = useState('');
    const [newContainerName, setNewContainerName] = useState('');
    const [newContainerNameHin, setNewContainerNameHin] = useState('');
    const [newContainerNameMar, setNewContainerNameMar] = useState('');
    const [newContainerNameGuj, setNewContainerNameGuj] = useState('');
    const [containerThumbnail, setContainerThumbnail] = useState(null);
    const [containerThumbnailUrl, setContainerThumbnailUrl] = useState('');
    const [allListenContainers, setAllListenContainers] = useState([]);
    const [selectedListenContainers, setSelectedListenContainers] = useState([]);
    const [selectedListenArtifact, setSelectedListenArtifact] = useState(null);
const [selectedWatchArtifact, setSelectedWatchArtifact] = useState(null);
const [listenSearch, setListenSearch] = useState('');
const [watchSearch, setWatchSearch] = useState('');

    const getDeities = async () => {
        const response = await _axios.get(`${ServerPath}/deity`);
        console.log('Deity result', response);
        const actualData = response?.data.data;
        setDeityResults(actualData);
    }

    const getJourneys = async () => {
        const response = await _axios.get(`${ServerPath}/tripdetails`);
        console.log('Journeys', response);
        const actualData = response?.data.data;
        setJourneyResults(actualData);
    }

    const getSaints = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/saints/list/1?limit=1000`); // Get all saints
            console.log('Saints result:', response);
            if (response?.data?.success === 1) {
                setSaintResults(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching saints:', error);
            toast.error('Failed to load saints');
        }
    };

    const getProjects = async () => {
        try {
            const response = await _axios.post(`${ServerPath}/projects`, {
                page: 1,
                limit: 1000,
                searchText: '',
                project_types: [],
                regions: [],
                beneficiaries: []
            });
            console.log('Projects result:', response);
            if (response?.data?.success === 1) {
                setProjectResults(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching projects:', error);
            toast.error('Failed to load projects');
        }
    };

    const getContainers = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/artifacts/containers`);
            console.log('Containers:', response);
            if (response?.data?.success) {
                setAllContainers(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching containers:', error);
            toast.error('Failed to load containers');
        }
    };
    const getListenContainers = async () => {
        try {
            const response = await _axios.get(`${ServerPath}/artifacts/listen-containers`);
            if (response?.data?.success) {
                setAllListenContainers(response.data.data);
            }
        } catch (error) {
            toast.error('Failed to load listen containers');
        }
    };


    const getReadArtifacts = async () => {
        try {
            const response = await axios.get(`${ServerPath}/artifacts/dropdown/read`);
            console.log('Read:', response);
            if (response?.data?.success) {
                setAllReadArtifacts(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching containers:', error);
            toast.error('Failed to load containers');
        }
    };

    const getListenArtifacts = async () => {
        try {
            const response = await axios.get(`${ServerPath}/artifacts/dropdown/listen`);
            console.log('Listen:', response);
            if (response?.data?.success) {
                setAllListenArtifacts(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching containers:', error);
            toast.error('Failed to load containers');
        }
    };

    const getWatchArtifacts = async () => {
        try {
            const response = await axios.get(`${ServerPath}/artifacts/dropdown/watch`);
            console.log('Watch:', response);
            if (response?.data?.success) {
                setAllWatchArtifacts(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching containers:', error);
            toast.error('Failed to load containers');
        }
    };

    useEffect(() => {
        getDeities();
        getJourneys();
        getContainers();
        getSaints();
        getProjects();
        getReadArtifacts();
        getListenArtifacts();
        getWatchArtifacts();
    }, []);

    useEffect(() => {
        if (
            formData.artifactType === 'audio or orals' &&
            formData.category === 'MANTRAS_CHANTS'
        ) {
            getListenContainers();
        }
    }, [formData.artifactType, formData.category]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log('Name :', name, 'Value : ', value)

        if (name === 'title') {
            if (value.length > 45) {
                toast.error('Title cannot exceed 45 characters');
                return;
            }
        }
        if(name === 'artifactType'){
            setReadFlag(false);
            setListenFlag(false);
            setWatchFlag(false);
            setSelectedListenId('');
setSelectedReadId('');
setSelectedReadArtifact(null);
setReadSearch('');
setSelectedWatchId('');
setSelectedListenArtifact(null);
setSelectedWatchArtifact(null);
setListenSearch('');
setWatchSearch('');
            setVideoSource('UPLOADED');
            setYoutubeUrlByLanguage({ en: '', hi: '', mr: '', gu: '' });
            // Reset all uploaded media so previous thumbnail/file previews don't persist
            setFiles(initialFilesState);
            setFilesByLanguage({
                en: { main: null, thumbnail: null },
                hi: { main: null },
                mr: { main: null },
                gu: { main: null }
            });
            setCurrentMediaByLanguage({
                en: { main_url: '' },
                hi: { main_url: '' },
                mr: { main_url: '' },
                gu: { main_url: '' }
            });
        }

        if (name === 'description') {
            // Description validation
            if (value.length > 300) {
                toast.error('Description cannot exceed 300 characters');
                return; // Prevent updating state if over limit
            }
            setCharCount(value.length);
        }

        if (name === 'relatedWaypoint') {
            setFormData(prev => ({
                ...prev,
                [name]: value,
                waypoint_id: null
            }));
            // Only search if there's at least 2 characters
            if (value.length > 2) {
                // Debounce the API call to avoid too many requests
                const timeoutId = setTimeout(() => {
                    _axios.get(`${ServerPath}/artifacts/search-waypoints?term=${value}`)
                        .then(response => {
                            if (response.data.success) {
                                setWaypointResults(response.data.data);
                            }
                        })
                        .catch(error => {
                            console.error('Error searching waypoints:', error);
                        });
                }, 300);
                return () => clearTimeout(timeoutId);
            } else {
                setWaypointResults([]);
            }
        }

        if (name === 'author') {
            if (value.length > 30) {
                toast.error('Author/Speaker name cannot exceed 30 characters');
                return;
            }
            // Filter authors as the user types
            const currentFilter = value.toLowerCase();
            const newFilteredAuthors = allAuthors.filter(author =>
                author.toLowerCase().includes(currentFilter)
            );
            setFilteredAuthors(newFilteredAuthors);
            // Ensure suggestions are shown if input has value or is focused
            setShowAuthorSuggestions(true);
        }

        // Update form data
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAuthorInputFocus = () => {
        setShowAuthorSuggestions(true);
        // On focus, filter based on current input, or show all if input is empty
        const currentFilter = formData.author.toLowerCase();
        setFilteredAuthors(allAuthors.filter(author =>
            author.toLowerCase().includes(currentFilter)
        ));
    };
    const handleAuthorInputBlur = () => {
        // Use a timeout to allow click events on suggestions to register
        setTimeout(() => {
            setShowAuthorSuggestions(false);
        }, 300);
    };

    const handleAuthorSelect = (selectedAuthor) => {
        console.log("Author selected:", selectedAuthor);
        setFormData(prev => ({
            ...prev,
            author: selectedAuthor
        }));
        setShowAuthorSuggestions(false); // Hide suggestions immediately after selection
        console.log("New formData.author after selection:", selectedAuthor);
    };


    const handleWaypointSelect = (waypoint) => {
        setFormData(prev => {
            // Check if waypoint is already selected
            const isAlreadySelected = prev.selectedWaypoints.some(w => w.wpt_id === waypoint.wpt_id);
            if (isAlreadySelected) return prev;

            // Add new waypoint to selectedWaypoints array
            const updatedWaypoints = [...prev.selectedWaypoints, waypoint];

            // Create comma-separated strings for names and IDs
            const waypointNames = updatedWaypoints.map(w => w.wpt_name).join(', ');
            const waypointIds = updatedWaypoints.map(w => w.wpt_id).join(',');

            return {
                ...prev,
                selectedWaypoints: updatedWaypoints,
                relatedWaypoint: '', // Clear the input field
                waypoint_id: waypointIds
            };
        });
        setWaypointResults([]); // Clear search results after selection
    };

    const handleJourneySelect = (journey) => {
        const isAlreadySelected = selectedJourneys.some(j => j.journey_id === journey.journey_id);
        if (isAlreadySelected) {
            return
        } else {
            const updatedJourneys = [...selectedJourneys, journey];
            setSelectedJourneys(updatedJourneys)
            setSearchJourney('');
        }
    };


    const handleDeitySelect = (deity) => {
        const isAlreadySelected = selectedDeities.some(d => d.deity_id === deity.deity_id);
        if (isAlreadySelected) {
            return
        } else {
            const updatedDeity = [...selectedDeities, deity];
            setSelectedDeities(updatedDeity)
            setSearchDeity('');

        }
    };


    const handleWaypointRemove = (waypointId) => {
        setFormData(prev => {
            const updatedWaypoints = prev.selectedWaypoints.filter(w => w.wpt_id !== waypointId);
            return {
                ...prev,
                selectedWaypoints: updatedWaypoints,
                relatedWaypoint: updatedWaypoints.map(w => w.wpt_name).join(', '),
                waypoint_id: updatedWaypoints.map(w => w.wpt_id).join(',')
            };
        });
    };

    const handleJourneyRemove = (journeyId) => {
        const updatedJourneys = selectedJourneys.filter(j => j.journey_id !== journeyId);
        setSelectedJourneys(updatedJourneys);

    };

    const handleDeityRemove = (deityId) => {
        const updatedDeities = selectedDeities.filter(d => d.deity_id !== deityId);
        setSelectedDeities(updatedDeities);

    };

    const handleSaintSelect = (saint) => {
        const isAlreadySelected = selectedSaints.some(s => s.id === saint.id);
        if (isAlreadySelected) {
            return;
        } else {
            const updatedSaints = [...selectedSaints, saint];
            setSelectedSaints(updatedSaints);
            setSearchSaint('');
        }
    };

    const handleSaintRemove = (saintId) => {
        const updatedSaints = selectedSaints.filter(s => s.id !== saintId);
        setSelectedSaints(updatedSaints);
    };

    const handleProjectSelect = (project) => {
        const isAlreadySelected = selectedProjects.some(p => p.project_id === project.project_id);
        if (isAlreadySelected) {
            return;
        } else {
            const updatedProjects = [...selectedProjects, project];
            setSelectedProjects(updatedProjects);
            setSearchProject('');
        }
    };

    const handleProjectRemove = (projectId) => {
        const updatedProjects = selectedProjects.filter(p => p.project_id !== projectId);
        setSelectedProjects(updatedProjects);
    };

    // Add these NEW handler functions
    const handleContainerCheckboxChange = (e) => {
        const checked = e.target.checked;
        setHasContainer(checked);
        // Reset container-related states when unchecked
        if (!checked) {
            setContainerOption('EXISTING');
            setSelectedContainers([]); // Changed from setSelectedContainerId('')
            setSearchContainer(''); // Clear search
            setNewContainerName('');
            setNewContainerNameHin('');
            setNewContainerNameMar('');
            setNewContainerNameGuj('');
            setContainerThumbnail(null);
            setContainerThumbnailUrl('');
        }
    };

    const handleContainerOptionChange = (e) => {
        const value = e.target.value;
        setContainerOption(value);
        // Reset relevant fields when switching
        if (value === 'EXISTING') {
            setNewContainerName('');
            setNewContainerNameHin('');
            setNewContainerNameMar('');
            setNewContainerNameGuj('');
            setContainerThumbnail(null);
            setContainerThumbnailUrl('');
        } else {
            setSelectedContainers([]); // Changed from setSelectedContainerId('')
            setSearchContainer('');
        }
    };

    const handleContainerThumbnailChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate thumbnail
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
        if (!allowedTypes.includes(file.type)) {
            toast.error("Container thumbnail must be in JPG, PNG or WEBP format");
            return;
        }

        const maxSize = 3 * 1024 * 1024; // 3MB
        if (file.size > maxSize) {
            toast.error('Container thumbnail size should be less than 3 MB');
            return;
        }

        setContainerThumbnail(file);

        // Upload to Azure
        try {
            const fileName = `container_thumbnail_${Date.now()}`;
            const uploadFolder = 'containers';
            const thumbnailUrl = await uploadImage(file, fileName, uploadFolder, 'containers');
            setContainerThumbnailUrl(thumbnailUrl);
            toast.success('Container thumbnail uploaded successfully');
        } catch (error) {
            console.error('Error uploading container thumbnail:', error);
            toast.error('Failed to upload container thumbnail');
        }
    };

    const handleContainerSelect = (container) => {
        const isAlreadySelected = selectedContainers.some(c => c.container_id === container.container_id);
        if (isAlreadySelected) {
            return;
        }
        setSelectedContainers(prev => [...prev, container]);
        setSearchContainer('');
    };

    const handleContainerRemove = (containerId) => {
        setSelectedContainers(prev => prev.filter(c => c.container_id !== containerId));
    };

    const handleListenContainerSelect = (container) => {
    const isAlreadySelected = selectedListenContainers.some(c => c.container_id === container.container_id);
    if (isAlreadySelected) {
        return;
    }
    setSelectedListenContainers(prev => [...prev, container]);
    setSearchContainer('');
};

const handleListenContainerRemove = (containerId) => {
    setSelectedListenContainers(prev => prev.filter(c => c.container_id !== containerId));
};

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            promotions: {
                ...prev.promotions,
                [name]: checked
            }
        }));
    };

    let counter = 1;
    const generateArtifactId = () => {
        const paddedCounter = String(counter).padStart(10, '0'); // Pad the counter with leading zeros
        counter++; // Increment the counter for the next call
        return paddedCounter;
    };

    const getArtifactTypeEnum = (type) => {
        const typeMap = {
            'text literature': 'TEXT_LITERATURE',
            'audio or orals': 'AUDIO_ORALS',
            'long videos': 'LONG_VIDEOS',
            'shorts or reels': 'SHORTS_REELS'
        };
        return typeMap[type.toLowerCase()] || type;
    };

    const FILE_VALIDATIONS = {
        TEXT_LITERATURE: {
            allowedTypes: ['application/pdf'],
            maxSize: 3 * 1024 * 1024, // 3MB
            errorMessage: "Please ensure the document is in PDF format. The file size should be less than 3 MB."
        },
        AUDIO_ORALS: {
            allowedTypes: ['audio/mpeg', 'audio/wave', 'audio/wav'],
            maxSize: 10 * 1024 * 1024, // 10MB
            errorMessage: "Please ensure the audio file is in MP3 format. The file size should be less than 10 MB."
        },
        LONG_VIDEOS: {
            allowedTypes: ['video/mp4', 'video/quicktime'],
            maxSize: 20 * 1024 * 1024, // 20MB
            errorMessage: "Please ensure the video file is in MP4/MOV format. The file size should be less than 20 MB, or the video length should not exceed 10 minutes."
        },
        SHORTS_REELS: {
            allowedTypes: ['video/mp4', 'video/quicktime',],
            maxSize: 10 * 1024 * 1024, // 10MB
            errorMessage: "Please ensure the shorts video file is in MP4/MOV format. The file size should be less than 10 MB, or the shorts/reels length should not exceed 60 seconds."
        }
    };

    const getVideoDuration = (file) => {
        return new Promise((resolve) => {
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);
                resolve(video.duration);
            };
            video.src = URL.createObjectURL(file);
        });
    };

    const validateFile = (file, artifactType, isThumbmail = false) => {
        if (isThumbmail) {
            const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'];
            if (!allowedTypes.includes(file.type)) {
                return { isValid: false, message: "Please ensure the thumbnail is in PNG, JPG or WEBP format." };
            }
            const maxSize = 3 * 1024 * 1024; // 3MB
            if (file.size > maxSize) {
                return { isValid: false, message: "Thumbnail size should be less than 3 MB" };
            }
            return { isValid: true };
        }
        const validation = FILE_VALIDATIONS[getArtifactTypeEnum(artifactType)];
        if (!validation) return { isValid: false, message: "Invalid artifact type" };

        if (!validation.allowedTypes.includes(file.type)) {
            return { isValid: false, message: validation.errorMessage };
        }

        if (file.size > validation.maxSize) {
            return { isValid: false, message: validation.errorMessage };
        }

        return { isValid: true };
    };

    const getUploadPath = (file, type, artifactType) => {
        const baseType = getArtifactTypeEnum(artifactType);
        let folder = '';

        switch (baseType) {
            case 'TEXT_LITERATURE':
                folder = type === 'main' ? 'pdf' : 'pdf/thumbnails';
                break;
            case 'AUDIO_ORALS':
                folder = type === 'main' ? 'audios' : 'audios/thumbnails';
                break;
            case 'LONG_VIDEOS':
                folder = type === 'main' ? 'videos' : 'videos/thumbnails';
                break;
            case 'SHORTS_REELS':
                folder = type === 'main' ? 'shorts' : 'shorts/thumbnails';
                break;
            default:
                folder = 'other';
        }

        return folder;
    };


    const handleMultilingualFileChange = async (e, type, languageCode) => {
        const file = e.target.files[0];
        if (!file) return;

        console.log('Multilingual File Change Started:', {
            type,
            languageCode,
            file: file.name,
            fileType: file.type
        });

        // Reset video state
        setIsPlaying(false);

        try {
            // Validation
            const validation = validateFile(file, formData.artifactType);
            if (!validation.isValid) {
                toast.error(validation.message);
                return;
            }

            // Check video duration for shorts
            if (formData.artifactType === 'shorts or reels' && file.type.startsWith('video/')) {
                const duration = await getVideoDuration(file);
                if (duration > 60) {
                    toast.error('Short video duration should not exceed 60 seconds');
                    return;
                }
            }

            // Update state immediately
            setFilesByLanguage(prev => ({
                ...prev,
                [languageCode]: {
                    ...prev[languageCode],
                    [type]: file
                }
            }));

            // Upload to Azure with language suffix
            const fileName = `${type}_${languageCode}_${Date.now()}`;
            const uploadFolder = getUploadPath(file, type, formData.artifactType);
            const fileUrl = await uploadImage(file, fileName, uploadFolder, uploadFolder.split('/')[0]);

            console.log('File uploaded successfully:', fileUrl);

            // Store URL for submission
            setCurrentMediaByLanguage(prev => ({
                ...prev,
                [languageCode]: {
                    ...prev[languageCode],
                    [`${type}_url`]: fileUrl
                }
            }));

            // CRITICAL: Generate thumbnail for video files (only for English to avoid duplicates)
            if (file.type.startsWith('video/') && languageCode === 'en') {
                console.log('Generating thumbnail for English video...');
                try {
                    const thumbnailFile = await generateThumbnail(file);
                    console.log('Thumbnail generated:', thumbnailFile);

                    // Set thumbnail file for main thumbnail display
                    setFiles(prev => ({
                        ...prev,
                        thumbnail: thumbnailFile
                    }));

                    // Upload thumbnail
                    const thumbnailFileName = `thumbnail_${Date.now()}`;
                    const thumbnailUploadFolder = getUploadPath(thumbnailFile, 'thumbnail', formData.artifactType);

                    const thumbnailUrl = await uploadImage(
                        thumbnailFile,
                        thumbnailFileName,
                        thumbnailUploadFolder,
                        thumbnailUploadFolder.split('/')[0]
                    );

                    console.log('Thumbnail uploaded:', thumbnailUrl);
                    toast.success('Thumbnail generated from video');
                } catch (error) {
                    console.error('Error generating thumbnail:', error);
                    toast.error('Failed to generate thumbnail from video');
                }
            }

            const langName = SUPPORTED_LANGUAGES.find(l => l.code === languageCode)?.name;
            toast.success(`${langName} file uploaded successfully`);

        } catch (error) {
            console.error('Error in handleMultilingualFileChange:', error);
            toast.error(`Failed to upload ${languageCode} file`);

            // Reset states on error
            setFilesByLanguage(prev => ({
                ...prev,
                [languageCode]: {
                    ...prev[languageCode],
                    [type]: null
                }
            }));
        }
    };

    // Add this function for multilingual file preview
    const renderMultilingualFilePreview = (file, type, languageCode) => {
        const existingUrl = currentMediaByLanguage[languageCode]?.main_url;

        // Safety check for filesByLanguage structure
        if (!filesByLanguage[languageCode]) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%' }}>
                    <span style={{ fontSize: '32px', color: '#A0AEC0' }}>+</span>
                    <p style={{
                        fontSize: '10px',
                        color: '#718096',
                        margin: '0',
                        whiteSpace: 'pre-line',
                        maxWidth: '200px'
                    }}>
                        {getUploadMessage(type, formData.artifactType)}
                    </p>
                </div>
            );
        }

        // Handle new uploaded video files with FULL CONTROLS like original
        if (file && file.type && file.type.startsWith('video/')) {
            return (
                <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                    <video
                        key={`${languageCode}-${file.name}`}
                        controls={isPlaying}
                        muted={!isPlaying}
                        playsInline
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '8px'
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsPlaying(!isPlaying);
                            const video = e.target;
                            if (!isPlaying) {
                                video.muted = false;
                                video.play();
                            } else {
                                video.pause();
                                video.currentTime = 0;
                                video.muted = true;
                            }
                        }}
                    >
                        <source src={URL.createObjectURL(file)} type={file.type} />
                    </video>

                    {!isPlaying && (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsPlaying(true);
                                const video = e.target.parentElement.querySelector('video');
                                if (video) {
                                    video.muted = false;
                                    video.play();
                                }
                            }}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '40px',
                                height: '40px',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            <div style={{
                                width: '0',
                                height: '0',
                                borderTop: '8px solid transparent',
                                borderBottom: '8px solid transparent',
                                borderLeft: '12px solid white',
                                marginLeft: '3px'
                            }} />
                        </div>
                    )}

                    <div style={{
                        position: 'absolute',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        padding: '8px',
                        background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.7))',
                        color: 'white',
                        fontSize: '12px',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        zIndex: 1
                    }}>
                        {file.name}
                    </div>

                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            triggerFileInput(`mainFile_${languageCode}`);
                        }}
                        style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            zIndex: 3
                        }}
                    >
                        Replace
                    </div>
                </div>
            );
        }

        // Handle existing uploaded video files
        if (!file && existingUrl && (formData.artifactType === 'long videos' || formData.artifactType === 'shorts or reels')) {
            return (
                <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                    <video
                        controls={false}
                        muted={true}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '8px'
                        }}
                    >
                        <source src={existingUrl} type="video/mp4" />
                    </video>
                    <div style={{
                        position: 'absolute',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        padding: '8px',
                        background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.7))',
                        color: 'white',
                        fontSize: '12px',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap'
                    }}>
                        Existing {SUPPORTED_LANGUAGES.find(l => l.code === languageCode)?.name} Video
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(0, 128, 0, 0.8)',
                            color: 'white',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '10px'
                        }}
                    >
                        ✓ Uploaded
                    </div>
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            triggerFileInput(`mainFile_${languageCode}`);
                        }}
                        style={{
                            position: 'absolute',
                            top: '8px',
                            left: '8px',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            zIndex: 3
                        }}
                    >
                        Replace
                    </div>
                </div>
            );
        }

        // Handle existing uploaded audio files
        if (!file && existingUrl && formData.artifactType === 'audio or orals') {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%', padding: '10px' }}>
                    <div className="mb-2">
                        <i className="bi bi-music-note" style={{ fontSize: '24px', color: '#4A5568' }}></i>
                    </div>
                    <span style={{
                        fontSize: '12px',
                        color: '#4A5568',
                        wordBreak: 'break-word'
                    }}>
                        Existing {SUPPORTED_LANGUAGES.find(l => l.code === languageCode)?.name} Audio
                    </span>
                    <div
                        style={{
                            backgroundColor: 'rgba(0, 128, 0, 0.8)',
                            color: 'white',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '10px',
                            marginTop: '4px'
                        }}
                    >
                        ✓ Uploaded
                    </div>
                </div>
            );
        }

        // Handle new uploaded audio files
        if (file && file.type && file.type.startsWith('audio/')) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%', padding: '10px' }}>
                    <div className="mb-2">
                        <i className="bi bi-music-note" style={{ fontSize: '24px', color: '#4A5568' }}></i>
                    </div>
                    <span style={{
                        fontSize: '12px',
                        color: '#4A5568',
                        wordBreak: 'break-word'
                    }}>
                        {file.name}
                    </span>
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            triggerFileInput(`mainFile_${languageCode}`);
                        }}
                        style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '10px',
                            marginTop: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Replace
                    </div>
                </div>
            );
        }

        // Default empty state
        if (!file) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%' }}>
                    <span style={{ fontSize: '32px', color: '#A0AEC0' }}>+</span>
                    <p style={{
                        fontSize: '10px',
                        color: '#718096',
                        margin: '0',
                        whiteSpace: 'pre-line',
                        maxWidth: '200px'
                    }}>
                        {getUploadMessage(type, formData.artifactType)}
                    </p>
                </div>
            );
        }

        // Handle other file types
        return (
            <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%', padding: '10px' }}>
                <div className="mb-2">
                    <i className="bi bi-file-earmark" style={{ fontSize: '24px', color: '#4A5568' }}></i>
                </div>
                <span style={{
                    fontSize: '12px',
                    color: '#4A5568',
                    wordBreak: 'break-word'
                }}>
                    {file.name}
                </span>
            </div>
        );
    };

    // Add updated validation functions
    // const validateContent = () => {
    //     // English content is mandatory
    //     if (formData.artifactType === 'text literature') {
    //         if (!contentByLanguage.en?.trim() || contentByLanguage.en.trim() === '<p><br></p>') {
    //             toast.error('English content is required');
    //             return false;
    //         }
    //     } else {
    //         // Add safety checks for filesByLanguage access
    //         if ((!filesByLanguage.en || !filesByLanguage.en.main) && (!currentMediaByLanguage.en || !currentMediaByLanguage.en.main_url)) {
    //             toast.error('English content file is required');
    //             return false;
    //         }
    //     }
    //     return true;
    // };

    // Add validation function for content
    const validateContent = () => {
        // At least ONE enabled language must have content
        const enabledLangCodes = Object.keys(enabledLanguages).filter(code => enabledLanguages[code]);

        if (formData.artifactType === 'text literature' && formData.category === 'EBOOKS') {
            // Ebooks: check R2 links in currentMediaByLanguage
            const hasAnyUrl = enabledLangCodes.some(langCode => currentMediaByLanguage[langCode]?.main_url?.trim());
            if (!hasAnyUrl) {
                toast.error('Please enter at least one PDF link for Ebooks');
                return false;
            }
        } else if (formData.artifactType === 'text literature') {
            // ✅ FIX: Check text editor content for TEXT_LITERATURE
            const hasAnyContent = enabledLangCodes.some(langCode => {
                const content = contentByLanguage[langCode];
                return content?.trim() &&
                    content.trim() !== '<p><br></p>' &&
                    content.trim() !== '<p></p>' &&
                    content.trim() !== '';
            });

            if (!hasAnyContent) {
                const enabledLangNames = enabledLangCodes
                    .map(code => SUPPORTED_LANGUAGES.find(l => l.code === code)?.name)
                    .join(', ');
                toast.error(`At least one language content is required from: ${enabledLangNames}`);
                return false;
            }
        } else if ((formData.artifactType === 'long videos' || formData.artifactType === 'shorts or reels') && videoSource === 'YOUTUBE') {
            // YouTube videos: every enabled language must have a valid YouTube URL
            for (const langCode of enabledLangCodes) {
                const url = youtubeUrlByLanguage[langCode]?.trim();
                const langName = SUPPORTED_LANGUAGES.find(l => l.code === langCode)?.name;
                if (!url) {
                    toast.error(`${langName} YouTube URL is required`);
                    return false;
                }
                if (!YOUTUBE_URL_REGEX.test(url)) {
                    toast.error(`${langName} YouTube URL is not valid`);
                    return false;
                }
            }
            // Thumbnail is mandatory for YouTube videos
            if (!files.thumbnail) {
                toast.error('Thumbnail is required for YouTube videos');
                return false;
            }
        } else {
            // ✅ FIX: Check file uploads for other artifact types
            const hasAnyFile = enabledLangCodes.some(langCode => {
                const hasNewFile = filesByLanguage[langCode]?.main;
                const hasExistingUrl = currentMediaByLanguage[langCode]?.main_url;
                return hasNewFile || hasExistingUrl;
            });

            if (!hasAnyFile) {
                const enabledLangNames = enabledLangCodes
                    .map(code => SUPPORTED_LANGUAGES.find(l => l.code === code)?.name)
                    .join(', ');
                toast.error(`At least one language file is required from: ${enabledLangNames}`);
                return false;
            }
        }

        return true;
    };




    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting || isSubmitted) return;

        try {
            setIsSubmitting(true);

            // Validate all 4 titles (now required)
            if (!validateTitles()) {
                setIsSubmitting(false);
                return;
            }
            if (!validateDescriptions()) {
                setIsSubmitting(false);
                return;
            }

            // Validate content based on artifact type
            if (!validateContent()) {
                setIsSubmitting(false);
                return;
            }

            // if (!formData.author) {
            //     toast.error('Please select Author/Speaker');
            //     setIsSubmitting(false);
            //     return;
            // }

            // if (!formData.languages) {
            //     toast.error('Please select Language');
            //     setIsSubmitting(false);
            //     return;
            // }


            if (!formData.artifactType || !formData.status || !formData.category) {
                toast.error('Please fill in all required fields');
                setIsSubmitting(false);
                return;
            }

            if (readFlag && selectedReadId.length === 0) {
                toast.error('Please Select Read ID');
                setIsSubmitting(false);
                return;
            }

            if (listenFlag && selectedListenId.length === 0) {
                toast.error('Please Select Listen ID');
                setIsSubmitting(false);
                return;
            }

            if (watchFlag && selectedWatchId.length === 0) {
                toast.error('Please Select Watch ID');
                setIsSubmitting(false);
                return;
            }

            // Prepare multilingual content data
            let mediaUrls = {
                media_url: '', // English
                media_url_hin: '',
                media_url_mar: '',
                media_url_guj: ''
            };

            let thumbnailUrl = '';

            if (formData.artifactType === 'text literature' && formData.category === 'EBOOKS') {
                // Ebooks: use R2 links from currentMediaByLanguage
                mediaUrls.media_url = enabledLanguages.en ? (currentMediaByLanguage.en?.main_url || null) : null;
                mediaUrls.media_url_hin = enabledLanguages.hi ? (currentMediaByLanguage.hi?.main_url || null) : null;
                mediaUrls.media_url_mar = enabledLanguages.mr ? (currentMediaByLanguage.mr?.main_url || null) : null;
                mediaUrls.media_url_guj = enabledLanguages.gu ? (currentMediaByLanguage.gu?.main_url || null) : null;
            } else if (formData.artifactType === 'text literature') {
                // Store HTML content for ENABLED languages only, NULL for disabled
                mediaUrls.media_url = enabledLanguages.en ? contentByLanguage.en : null;
                mediaUrls.media_url_hin = enabledLanguages.hi ? (contentByLanguage.hi || null) : null;
                mediaUrls.media_url_mar = enabledLanguages.mr ? (contentByLanguage.mr || null) : null;
                mediaUrls.media_url_guj = enabledLanguages.gu ? (contentByLanguage.gu || null) : null;
            } else if ((formData.artifactType === 'long videos' || formData.artifactType === 'shorts or reels') && videoSource === 'YOUTUBE') {
                // YouTube videos: store the YouTube URL per enabled language in the same media_url* columns
                mediaUrls.media_url = enabledLanguages.en ? (youtubeUrlByLanguage.en?.trim() || null) : null;
                mediaUrls.media_url_hin = enabledLanguages.hi ? (youtubeUrlByLanguage.hi?.trim() || null) : null;
                mediaUrls.media_url_mar = enabledLanguages.mr ? (youtubeUrlByLanguage.mr?.trim() || null) : null;
                mediaUrls.media_url_guj = enabledLanguages.gu ? (youtubeUrlByLanguage.gu?.trim() || null) : null;
            } else {
                // Handle file uploads for non-text artifacts
                // At least ONE enabled language must have a file (validated earlier)

                mediaUrls.media_url = enabledLanguages.en ? (currentMediaByLanguage.en?.main_url || null) : null;
                mediaUrls.media_url_hin = enabledLanguages.hi ? (currentMediaByLanguage.hi?.main_url || null) : null;
                mediaUrls.media_url_mar = enabledLanguages.mr ? (currentMediaByLanguage.mr?.main_url || null) : null;
                mediaUrls.media_url_guj = enabledLanguages.gu ? (currentMediaByLanguage.gu?.main_url || null) : null;
            }

            // Upload thumbnail to Azure
            if (files.thumbnail) {
                const thumbnailFileName = `thumbnail_${Date.now()}`;
                thumbnailUrl = await uploadImage(
                    files.thumbnail,
                    thumbnailFileName,
                    'thumbnails',
                    'images'
                );
            }

            // Convert category string to ID using the mapping
            const categoryId = CATEGORY_MAP[formData.category];
            const firstWaypoint = formData.selectedWaypoints[0] || {};

            const deities = selectedDeities?.map((deity) => deity?.deity_id);
            const journeys = selectedJourneys.map((journey) => journey?.journey_id);
            const saints = selectedSaints.map((saint) => saint?.id);
            const projects = selectedProjects.map((project) => project?.project_id);

            let containerIdToUse = null;
            if (hasContainer && formData.artifactType === 'text literature' && formData.category === 'MANTRAS') {
                if (containerOption === 'NEW') {
                    // Validate new container fields
                    if (!newContainerName.trim()) {
                        toast.error('Container name is required');
                        setIsSubmitting(false);
                        return;
                    }
                    if (!containerThumbnailUrl) {
                        toast.error('Container thumbnail is required');
                        setIsSubmitting(false);
                        return;
                    }
                    // Create new container
                    try {
                        const containerData = {
                            container_name: newContainerName.trim(),
                            container_name_hin: newContainerNameHin.trim() || null,
                            container_name_mar: newContainerNameMar.trim() || null,
                            container_name_guj: newContainerNameGuj.trim() || null,
                            container_thumbnail_url: containerThumbnailUrl,
                            created_by: currentId
                        };
                        const containerResponse = await _axios.post(`${ServerPath}/artifacts/containers`, containerData);
                        if (containerResponse.data.success) {
                            containerIdToUse = containerResponse.data.data.container_id;
                            toast.success('Container created successfully');
                        }
                    } catch (error) {
                        console.error('Error creating container:', error);
                        toast.error(error.response?.data?.message || 'Failed to create container');
                        setIsSubmitting(false);
                        return;
                    }
                } else {
                    // Use existing containers (multi-select)
                    if (selectedContainers.length === 0) {
                        toast.error('Please select at least one container');
                        setIsSubmitting(false);
                        return;
                    }
                    containerIdToUse = selectedContainers.map(c => c.container_id).join(',');
                }
            }

            let listenContainerIdToUse = null;
            if (
                hasContainer &&
                formData.artifactType === 'audio or orals' &&
                formData.category === 'MANTRAS_CHANTS'
            ) {
                if (containerOption === 'NEW') {
                    // Validate
                    if (!newContainerName.trim()) {
                        toast.error('Container name is required');
                        setIsSubmitting(false);
                        return;
                    }
                    if (!containerThumbnailUrl) {
                        toast.error('Container thumbnail is required');
                        setIsSubmitting(false);
                        return;
                    }

                    try {
                        const containerData = {
                            container_name: newContainerName.trim(),
                            container_name_hin: newContainerNameHin.trim() || null,
                            container_name_mar: newContainerNameMar.trim() || null,
                            container_name_guj: newContainerNameGuj.trim() || null,
                            container_thumbnail_url: containerThumbnailUrl,
                            created_by: currentId
                        };

                        const res = await _axios.post(
                            `${ServerPath}/artifacts/listen-containers/`,
                            containerData
                        );

                        if (res.data.success) {
                            listenContainerIdToUse = res.data.data.container_id;
                        }
                    } catch (err) {
                        toast.error(err.response?.data?.message || 'Failed to create listen container');
                        setIsSubmitting(false);
                        return;
                    }
                } else {
                    if (selectedListenContainers.length === 0) {
                        toast.error('Please select at least one container');
                        setIsSubmitting(false);
                        return;
                    }
                    listenContainerIdToUse = selectedListenContainers
                        .map(c => c.container_id)
                        .join(',');
                }
            }



            // Create artifact data object
            const artifactData = {
                title: formData.title,
                title_hin: formData.title_hin || null,
                title_mar: formData.title_mar || null,
                title_guj: formData.title_guj || null,
                lang_flag: Object.keys(enabledLanguages)     // ← ADD THIS LINE
                    .filter(code => enabledLanguages[code])  // ← ADD THIS LINE
                    .join(','),
                // short_description: enabledLanguages.en ? (descriptionByLanguage.en || null) : null,
                // short_description_hin: enabledLanguages.hi ? (descriptionByLanguage.hi || null) : null,
                // short_description_mar: enabledLanguages.mr ? (descriptionByLanguage.mr || null) : null,
                // short_description_guj: enabledLanguages.gu ? (descriptionByLanguage.gu || null) : null,
                short_description: descriptionByLanguage.en || null,
short_description_hin: descriptionByLanguage.hi || null,
short_description_mar: descriptionByLanguage.mr || null,
short_description_guj: descriptionByLanguage.gu || null,
                artifact_type: getArtifactTypeEnum(formData.artifactType),
                video_source: (formData.artifactType === 'long videos' || formData.artifactType === 'shorts or reels')
                    ? videoSource
                    : null,
                status: formData.status.toUpperCase(),
                ...mediaUrls, // Spread all media URLs
                thumbnail_url: thumbnailUrl,
                file_size_bytes: formData.artifactType === 'text literature'
                    ? new Blob([contentByLanguage.en]).size
                    : ((formData.artifactType === 'long videos' || formData.artifactType === 'shorts or reels') && videoSource === 'YOUTUBE'
                        ? 0
                        : (filesByLanguage.en?.main?.size || 0)),
                is_trending: formData.promotions.trending,
                is_by_guruji: formData.promotions.byGuruji,
                subscription_type: formData.subscriptionType.toUpperCase(),
                is_a_part_of_course: formData.is_a_part_of_course,
                is_a_part_of_explore: formData.is_a_part_of_explore,
                category_id: categoryId,
                created_by: currentId,
                media_type: formData.artifactType === 'text literature' ? 'text/html' : (filesByLanguage.en?.main?.type || ''),
                original_filename: formData.artifactType === 'text literature'
                    ? `${formData.title.replace(/\s+/g, '_')}.html`
                    : (filesByLanguage.en?.main?.name || ''),
                storage_path: mediaUrls.media_url,
                file_type: formData.artifactType === 'text literature' ? 'HTML' : getFileTypeFromMimeType(filesByLanguage.en?.main?.type || ''),
                waypoint_id: firstWaypoint.wpt_id || null,
                waypoint_name: firstWaypoint.wpt_name || null,
                additional_waypoints: formData.selectedWaypoints.slice(1),
                html_content: formData.artifactType === 'text literature' ? contentByLanguage.en : null,
                lyrics_data: files.lyricsData || null,
                // author: formData.author || null,
                // languages: formData.languages || null,
                deity_id: deities.join(','),
                journey_id: journeys.join(','),
                saint_id: saints.join(','),
                project_id: projects.join(','),
                container_id: containerIdToUse,
                listen_container_id: listenContainerIdToUse,
                listen_flag: listenFlag ? 1 : 0,
                read_flag: readFlag ? 1 : 0,
                watch_flag: watchFlag ? 1 : 0,
                listen_id: selectedListenId,
                read_id: selectedReadId,
                watch_id: selectedWatchId
            };

            const response = await _axios.post(`${ServerPath}/artifacts`, artifactData);

            if (response.data.success) {
                setIsSubmitted(true);
                onHide();
                toast.success('Your record has been successfully saved.');
                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            }
        } catch (error) {
            if (!isSubmitted) {
                console.error('Error details:', error);
                toast.error(error.response?.data?.message || 'Failed to create artifact');
                setIsSubmitting(false);
            }
        }
    };
    // Helper function to determine file type from MIME type
    const getFileTypeFromMimeType = (mimeType) => {
        const mimeTypeMap = {
            'application/pdf': 'PDF',
            'audio/mpeg': 'MP3',
            'audio/wave': 'MP3',
            'audio/wav': 'MP3',
            'video/mp4': 'MP4',
            'video/quicktime': 'MOV',
            'image/gif': 'GIF'
        };
        return mimeTypeMap[mimeType] || 'PDF';
    };

    const handleFileChange = async (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        // Reset video state when new file is selected
        setIsPlaying(false);

        if (type === 'main') {
            const validation = validateFile(file, formData.artifactType);
            if (!validation.isValid) {
                toast.error(validation.message);
                return;
            }
            if (getArtifactTypeEnum(formData.artifactType) === 'SHORTS_REELS' && file.type.startsWith('video/')) {
                const duration = await getVideoDuration(file);
                if (duration > 60) {
                    toast.error('Short video duration should not exceed 60 seconds');
                    return;
                }
            }

            // Clear any existing object URLs to prevent memory leaks
            if (files.main && files.main.preview) {
                URL.revokeObjectURL(files.main.preview);
            }

            // Create new preview URL for video
            const previewUrl = URL.createObjectURL(file);
            const fileWithPreview = Object.assign(file, { preview: previewUrl });

            // Set the main file with preview
            setFiles(prev => ({
                ...prev,
                [type]: fileWithPreview
            }));

            // Generate thumbnail for video or GIF
            if (file.type.startsWith('video/') || file.type === 'image/gif') {
                try {
                    let thumbnailFile;
                    if (file.type === 'image/gif') {
                        // Create thumbnail from GIF
                        thumbnailFile = new File([file], 'gif-thumbnail.png', { type: 'image/png' });
                        thumbnailFile.preview = URL.createObjectURL(file);
                    } else {
                        // Use existing video thumbnail generation
                        thumbnailFile = await generateThumbnail(file);
                    }

                    // Clear existing thumbnail previews
                    if (files.thumbnail && files.thumbnail.preview) {
                        URL.revokeObjectURL(files.thumbnail.preview);
                    }

                    setFiles(prev => ({
                        ...prev,
                        thumbnail: thumbnailFile
                    }));
                    toast.success('Thumbnail generated successfully');

                } catch (error) {
                    console.error('Error generating thumbnail:', error);
                    toast.error('Failed to generate thumbnail');
                }
            }

        } else if (type === 'thumbnail') {
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
            if (!allowedTypes.includes(file.type)) {
                toast.error("Thumbnail must be in JPG, PNG or WEBP format");
                return;
            }

            if (!file.type.startsWith('image/')) {
                toast.error("Thumbnail must be an image file");
                return;
            }

            setFiles(prev => ({
                ...prev,
                thumbnail: file
            }));
        }
        // else if (type === 'lyrics') {
        //     const allowedTypes = ['application/json', 'text/plain'];
        //     if (!allowedTypes.some(t => file.type.includes(t)) && !file.name.match(/\.(json|lrc)$/i)) {
        //         toast.error("Lyrics must be in JSON or LRC format");
        //         return;
        //     }

        //     const reader = new FileReader();
        //     reader.onload = async (e) => {
        //         try {
        //             const content = e.target.result;
        //             let lyricsData;

        //             if (file.name.endsWith('.json')) {
        //                 lyricsData = JSON.parse(content);
        //                 if (!lyricsData.lines || !Array.isArray(lyricsData.lines)) {
        //                     toast.error("Invalid lyrics format. Expected {lines: [{time: number, text: string}]}");
        //                     return;
        //                 }
        //             } else if (file.name.endsWith('.lrc')) {
        //                 lyricsData = parseLRCToJSON(content);
        //             }

        //             setFiles(prev => ({
        //                 ...prev,
        //                 lyrics: file,
        //                 lyricsData: lyricsData
        //             }));

        //             toast.success('Lyrics uploaded successfully');
        //         } catch (error) {
        //             console.error('Error parsing lyrics:', error);
        //             toast.error("Invalid lyrics file format");
        //         }
        //     };
        //     reader.readAsText(file);
        // }
    };

    const getUploadMessage = (type, artifactType) => {
        if (!artifactType) return '';

        if (type === 'thumbnail') {
            return 'Please ensure the document is in JPG, PNG format.';
        }

        const validation = FILE_VALIDATIONS[getArtifactTypeEnum(artifactType)];
        if (!validation) return '';
        // Special case for audio
        if (artifactType.toLowerCase() === 'audio or orals') {
            return `Please ensure the audio file is in MP3 format. The file size should be less than 10 MB`;
        }

        const allowedTypes = validation.allowedTypes.map(type => {
            switch (type) {
                case 'application/pdf': return 'PDF';
                case 'audio/mpeg':
                case 'audio/wave':
                case 'audio/wav': return 'MP3';
                case 'video/mp4': return 'MP4';
                case 'video/quicktime': return 'MOV';
                case 'image/gif': return 'GIF';
                default: return type;
            }
        }).join(', ');

        const sizeInMB = validation.maxSize / (1024 * 1024);
        return `Please ensure the document is in ${allowedTypes} format.\nThe file size should be less than ${sizeInMB} MB`;
    };

    const renderFilePreview = (file, type) => {
        if (!file) {
            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%' }}>
                    <span style={{ fontSize: '32px', color: '#A0AEC0' }}>+</span>
                    <p style={{
                        fontSize: '10px',
                        color: '#718096',
                        margin: '0',
                        whiteSpace: 'pre-line',
                        maxWidth: '200px'
                    }}>
                        {getUploadMessage(type, formData.artifactType)}
                    </p>
                </div>
            );
        }
        if (type === 'lyrics') {
            if (!file) {
                return (
                    <div className="d-flex flex-column align-items-center justify-content-center text-center" style={{ height: '100%' }}>
                        <span style={{ fontSize: '32px', color: '#A0AEC0' }}>♪</span>
                        <p style={{
                            fontSize: '10px',
                            color: '#718096',
                            margin: '0',
                            whiteSpace: 'pre-line',
                            maxWidth: '200px'
                        }}>
                            Upload lyrics in JSON or LRC format
                        </p>
                    </div>
                );
            }

            return (
                <div className="d-flex flex-column align-items-center justify-content-center text-center"
                    style={{ height: '100%', padding: '10px' }}>
                    <div className="mb-2">
                        <i className="bi bi-music-note-list" style={{ fontSize: '24px', color: '#4A5568' }}></i>
                    </div>
                    <span style={{
                        fontSize: '12px',
                        color: '#4A5568',
                        wordBreak: 'break-word'
                    }}>
                        {file.name}
                    </span>
                    {files.lyricsData && (
                        <span style={{ fontSize: '10px', color: '#48C3F3', marginTop: '4px' }}>
                            {files.lyricsData.lines.length} lines
                        </span>
                    )}
                </div>
            );
        }

        if (file.type.startsWith('image/')) {
            const previewUrl = file.preview || URL.createObjectURL(file);
            return (
                <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                    <img
                        src={previewUrl}
                        alt="Preview"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '8px'
                        }}
                    />
                    <div style={{
                        position: 'absolute',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        padding: '8px',
                        background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.7))',
                        color: 'white',
                        fontSize: '12px',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap'
                    }}>
                        {file.name}
                    </div>
                </div>
            );
        }

        // Handle video files
        if (file.type.startsWith('video/')) {
            return (
                <div className="position-relative" style={{ width: '100%', height: '100%' }}
                    onClick={(e) => e.stopPropagation()}>
                    <video
                        key={file.name}
                        controls={isPlaying}
                        muted={!isPlaying}
                        playsInline
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            backgroundColor: '#F7FAFC'
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setIsPlaying(!isPlaying);
                            const video = e.target;
                            if (!isPlaying) {
                                video.muted = false;
                                video.play();
                            } else {
                                video.pause();
                                video.currentTime = 0;
                                video.muted = true;
                            }
                        }}
                    >
                        <source src={URL.createObjectURL(file)} type={file.type} />
                        Your browser does not support the video tag.
                    </video>

                    {!isPlaying && (
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsPlaying(true);
                                const video = e.target.parentElement.previousElementSibling;
                                video.play();
                            }}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '40px',
                                height: '40px',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            <div style={{
                                width: '0',
                                height: '0',
                                borderTop: '8px solid transparent',
                                borderBottom: '8px solid transparent',
                                borderLeft: '12px solid white',
                                marginLeft: '3px'
                            }} />
                        </div>
                    )}

                    <div style={{
                        position: 'absolute',
                        bottom: '0',
                        left: '0',
                        right: '0',
                        padding: '8px',
                        background: 'linear-gradient(transparent, rgba(0, 0, 0, 0.7))',
                        color: 'white',
                        fontSize: '12px',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        zIndex: 1
                    }}>
                        {file.name}
                    </div>
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            triggerFileInput('mainFile');
                        }}
                        style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            zIndex: 3
                        }}
                    >
                        Replace
                    </div>
                </div>
            );
        }

        // Handle other file types (PDF, audio, etc.)
        return (
            <div className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: '100%', padding: '10px' }}>
                <div className="mb-2">
                    <i className="bi bi-file-earmark-text" style={{ fontSize: '24px', color: '#4A5568' }}></i>
                </div>
                <span style={{
                    fontSize: '12px',
                    color: '#4A5568',
                    wordBreak: 'break-word',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical'
                }}>
                    {file.name}
                </span>
            </div>
        );
    };

    const generateThumbnail = (videoFile) => {
        return new Promise((resolve) => {
            const video = document.createElement('video');
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            video.autoplay = false;
            video.muted = true;
            video.src = URL.createObjectURL(videoFile);

            video.onloadeddata = () => {
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                video.currentTime = Math.min(1, video.duration);
            };

            video.onseeked = () => {
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                canvas.toBlob((blob) => {
                    const thumbnailFile = new File([blob], 'auto-thumbnail.png', { type: 'image/png' });
                    thumbnailFile.preview = URL.createObjectURL(blob);
                    resolve(thumbnailFile);
                    URL.revokeObjectURL(video.src);
                }, 'image/png', 0.8);
            };
        });
    };

    const triggerFileInput = (inputId) => {
        document.getElementById(inputId).click();
    };

    const resetForm = () => {
        setFormData(initialFormState);
        setFiles(initialFilesState);
        setCharCount(0);
        setWaypointResults([]);
        setHtmlContent('');
        setShowPreview(false);
        setHasLyrics(false);
        setHasContainer(false);
        setContainerOption('EXISTING');
        setSelectedContainers([]); // Changed from setSelectedContainerId('')
        setSearchContainer(''); // Add this
        setAllListenContainers([]);
        setSelectedListenContainers([]);
        setNewContainerName('');
        setNewContainerNameHin('');
        setNewContainerNameMar('');
        setNewContainerNameGuj('');
        setContainerThumbnail(null);
        setContainerThumbnailUrl('');
        setSelectedListenId('');
setSelectedReadId('');
setSelectedReadArtifact(null);
setReadSearch('');
setSelectedWatchId('');
setSelectedListenArtifact(null);
setSelectedWatchArtifact(null);
setListenSearch('');
setWatchSearch('');
        setReadFlag(false);
        setListenFlag(false);
        setWatchFlag(false);
        setVideoSource('UPLOADED');
        setYoutubeUrlByLanguage({ en: '', hi: '', mr: '', gu: '' });
    };
    // Modified onHide handler
    const handleClose = () => {
        resetForm();
        onHide();
    };

    const handleLanguageToggle = (languageCode) => {
        setEnabledLanguages(prev => ({
            ...prev,
            [languageCode]: !prev[languageCode]
        }));

        // Clear the title when language is disabled
        if (enabledLanguages[languageCode]) {
            const field = SUPPORTED_LANGUAGES.find(l => l.code === languageCode)?.field;
            if (field) {
                setFormData(prev => ({
                    ...prev,
                    [field]: ''
                }));
            }
        }
    };

    const handleMultilingualTitleChange = (e) => {
        const { name, value } = e.target;

        // Validate length
        if (value.length > 45) {
            toast.error('Title cannot exceed 45 characters');
            return;
        }

        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validateTitles = () => {
        // All 4 titles are now required
        const requiredLanguages = ['en', 'hi', 'mr', 'gu'];

        for (const langCode of requiredLanguages) {
            const field = SUPPORTED_LANGUAGES.find(l => l.code === langCode)?.field;
            if (!formData[field]?.trim() || formData[field].trim().length < 3) {
                const langName = SUPPORTED_LANGUAGES.find(l => l.code === langCode)?.name;
                toast.error(`${langName} title is required (minimum 3 characters)`);
                return false;
            }
        }
        return true;
    };

    // const validateDescriptions = () => {
    //     // For video types, all 4 descriptions are required
    //     if (formData.artifactType === 'long videos' || formData.artifactType === 'shorts or reels') {
    //         const requiredLanguages = ['en', 'hi', 'mr', 'gu'];

    //         for (const langCode of requiredLanguages) {
    //             const field = SUPPORTED_LANGUAGES.find(l => l.code === langCode)?.descField;
    //             if (!descriptionByLanguage[langCode]?.trim() || descriptionByLanguage[langCode].trim().length < 10) {
    //                 const langName = SUPPORTED_LANGUAGES.find(l => l.code === langCode)?.name;
    //                 toast.error(`${langName} description is required (minimum 10 characters)`);
    //                 return false;
    //             }
    //         }
    //     } else {
    //         // For other types, only English description is required
    //         if (!descriptionByLanguage.en?.trim() || descriptionByLanguage.en.trim().length < 10) {
    //             toast.error('English description is required (minimum 10 characters)');
    //             return false;
    //         }
    //     }
    //     return true;
    // };
    const validateDescriptions = () => {
        // Only validate descriptions for ENABLED languages (checked checkboxes)
        for (const langCode of Object.keys(enabledLanguages)) {
            if (enabledLanguages[langCode]) {  // ← Only check enabled languages
                if (!descriptionByLanguage[langCode]?.trim() || descriptionByLanguage[langCode].trim().length < 10) {
                    const langName = SUPPORTED_LANGUAGES.find(l => l.code === langCode)?.name;
                    toast.error(`${langName} description is required (minimum 10 characters)`);
                    return false;
                }
            }
        }
        return true;
    };



    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            centered
            className="create-artifact-modal"
            style={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center'
            }}
        >
            <Modal.Header closeButton className="border-bottom-1 pb-2">
                <Modal.Title>Create Artifact</Modal.Title>
            </Modal.Header>

            <Modal.Body className="px-4 py-3"
                style={{
                    maxHeight: 'calc(90vh - 215px)',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    '&::-webkit-scrollbar': {
                        display: 'none'
                    }
                }}>
                <Form onSubmit={handleSubmit}>
                    {/* Basics Section */}
                    <div className="mb-4">
                        <h6 className="text-primary mb-4" style={{ fontSize: '16px', color: '#6366F1' }}>Basics</h6>

                        <div className="row mb-3">
                            {/* Artifact Type */}
                            <div className="col-3 pe-2">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Artifact Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="artifactType"
                                        value={formData.artifactType}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '44px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF'
                                        }}
                                    >
                                        <option value="" hidden>Select Artifact</option>
                                        <option value="text literature">Read</option>
                                        <option value="audio or orals">Listen</option>
                                        <option value="long videos">Watch{'(Long Videos)'}</option>
                                        <option value="shorts or reels">Watch{'(Shorts or Reels)'}</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>

                            {/* Status */}
                            <div className="col-3 px-2">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Status <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="status"
                                        value={formData.status}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '44px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF'
                                        }}
                                    >
                                        <option value="" hidden>Select Status</option>
                                        <option value="new">New</option>
                                        <option value="active">Active</option>
                                        <option value="archived">Archived</option>
                                    </Form.Select>
                                </Form.Group>
                            </div>

                            {/* Select Content Languages */}
                            <div className="col-3 px-2">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Select Content Languages <span className="text-danger">*</span>
                                    </Form.Label>
                                    <div style={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr',
                                        gap: '8px',
                                        padding: '10px',
                                        backgroundColor: '#FFFFFF'
                                    }}>
                                        {SUPPORTED_LANGUAGES.map(lang => (
                                            <Form.Check
                                                key={lang.code}
                                                type="checkbox"
                                                id={`lang-${lang.code}`}
                                                label={lang.name}
                                                checked={enabledLanguages[lang.code]}
                                                onChange={() => handleLanguageToggle(lang.code)}
                                                style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500'
                                                }}
                                            />
                                        ))}
                                    </div>
                                </Form.Group>
                            </div>

                            {/* Category */}
                            <div className="col-3 ps-2">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Category <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="category"
                                        value={formData.category}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '44px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF'
                                        }}
                                    >
                                        <option value="" hidden>Select Category</option>
                                        {formData.artifactType === 'text literature' && (
                                            <>
                                                <option value="EBOOKS">Ebooks</option>
                                                <option value="SCRIPTURES">About Teerthas</option>
                                                <option value="ESSAYS_BLOGS">Blogs & Research</option>
                                                <option value="POOJA_VIDHIS">Pooja/Havan Vidhis</option>
                                                <option value="DIVINE_QUOTES">Divine Quotes</option>
                                                <option value="MANTRAS">Mantras</option>
                                                <option value="AARTIS">Aartis</option>
                                            </>
                                        )}
                                        {formData.artifactType === 'audio or orals' && (
                                            <>
                                                <option value="MANTRAS_CHANTS">Mantras & Chants</option>
                                                <option value="STOTRA_RECITATIONS">Stotra Recitations</option>
                                                <option value="AARTI_DAILY_RITUALS">Aarti & Daily Rituals</option>
                                                <option value="DISCOURSES_PRAVACHANS">Discourses & Pravachans</option>
                                                <option value="AUDIOBOOKS">Audio Books & Podcasts</option>
                                                <option value="BHAJANS_KIRTANS">Bhajans</option>
                                            </>
                                        )}
                                        {(formData.artifactType === 'long videos' || formData.artifactType === 'shorts or reels') && (
                                            <>
                                                <option value="DISCOURSES">Discourses</option>
                                                <option value="SATSANGS_QA">Satsangs & Q&A</option>
                                                <option value="SPIRITUAL_EXPERIENCES">Spiritual Experiences</option>
                                                <option value="LIFE_WELL_BEING">Life & Well-Being</option>
                                                <option value="DIVINE_MOMENTS">Divine Moments</option>
                                                <option value="GUIDED_PRACTICES">Guided Practices</option>
                                                <option value="MANTRA_CHANTING">Mantra Chanting</option>
                                                <option value="SCRIPTURAL_TEACHINGS">Scriptural Teachings</option>
                                                <option value="PARIKRAMA_SNIPPETS">Parikrama Snippets</option>
                                            </>
                                        )}
                                    </Form.Select>
                                </Form.Group>
                            </div>
                        </div>

                        {/* Video Source toggle - only for video artifact types */}
                        {(formData.artifactType === 'long videos' || formData.artifactType === 'shorts or reels') && (
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div className="d-flex align-items-center" style={{ gap: '24px' }}>
                                        <Form.Check
                                            type="radio"
                                            id="videoSource-uploaded"
                                            name="videoSource"
                                            label="Uploaded Video"
                                            checked={videoSource === 'UPLOADED'}
                                            onChange={() => {
                                                setVideoSource('UPLOADED');
                                                setYoutubeUrlByLanguage({ en: '', hi: '', mr: '', gu: '' });
                                                setFiles(initialFilesState);
                                                setFilesByLanguage({
                                                    en: { main: null, thumbnail: null },
                                                    hi: { main: null },
                                                    mr: { main: null },
                                                    gu: { main: null }
                                                });
                                                setCurrentMediaByLanguage({
                                                    en: { main_url: '' },
                                                    hi: { main_url: '' },
                                                    mr: { main_url: '' },
                                                    gu: { main_url: '' }
                                                });
                                            }}
                                            style={{ fontSize: '14px', fontWeight: '500', color: '#4A5568' }}
                                        />
                                        <Form.Check
                                            type="radio"
                                            id="videoSource-youtube"
                                            name="videoSource"
                                            label="YouTube Video"
                                            checked={videoSource === 'YOUTUBE'}
                                            onChange={() => {
                                                setVideoSource('YOUTUBE');
                                                setFiles(initialFilesState);
                                                setFilesByLanguage({
                                                    en: { main: null, thumbnail: null },
                                                    hi: { main: null },
                                                    mr: { main: null },
                                                    gu: { main: null }
                                                });
                                                setCurrentMediaByLanguage({
                                                    en: { main_url: '' },
                                                    hi: { main_url: '' },
                                                    mr: { main_url: '' },
                                                    gu: { main_url: '' }
                                                });
                                                setYoutubeUrlByLanguage({ en: '', hi: '', mr: '', gu: '' });
                                            }}
                                            style={{ fontSize: '14px', fontWeight: '500', color: '#4A5568' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Title Inputs Section - All 4 in one horizontal line */}
                        {/* Update the title inputs to have better spacing */}
                        <div className="row mb-3">
                            <div className="col-12">
                                <Form.Label className="mb-3" style={{ color: '#4A5568', fontWeight: '500' }}>
                                    Artifact Title <span className="text-danger">*</span>
                                </Form.Label>
                                <div className="row">
                                    {SUPPORTED_LANGUAGES.map(lang => (
                                        <div key={lang.code} className="col-3">
                                            <Form.Group>
                                                <Form.Label className="mb-2" style={{
                                                    color: '#4A5568',  // ← REMOVED enabledLanguages check
                                                    fontWeight: '500',
                                                    fontSize: '14px'
                                                }}>
                                                    {lang.name} Title <span className="text-danger">*</span>
                                                </Form.Label>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type="text"
                                                        name={lang.field}
                                                        placeholder={`Enter Title in ${lang.name}`}
                                                        value={formData[lang.field] || ''}
                                                        onChange={handleMultilingualTitleChange}
                                                        // disabled={!enabledLanguages[lang.code]}
                                                        disabled={false}
                                                        style={{
                                                            height: '50px',  // ← INCREASED HEIGHT
                                                            paddingRight: '50px',  // ← MORE PADDING FOR CHAR COUNT
                                                            border: '1px solid #E2E8F0',
                                                            backgroundColor: '#FFFFFF',
                                                            color: '#1A202C'
                                                        }}
                                                    />
                                                    <div
                                                        className="position-absolute"
                                                        style={{
                                                            bottom: '12px',  // ← ADJUSTED POSITION
                                                            right: '15px',
                                                            fontSize: '11px',
                                                            color: '#6B7280'
                                                        }}
                                                    >
                                                        {(formData[lang.field] || '').length}/45
                                                    </div>
                                                </div>
                                            </Form.Group>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Description Section - Full Width Below Titles */}
                        {/* Replace the single description section with multilingual descriptions */}
                        <div className="row mb-3">
                            <div className="col-12">
                                <Form.Label className="mb-3" style={{ color: '#4A5568', fontWeight: '500' }}>
                                    Short Description <span className="text-danger">*</span>
                                </Form.Label>
                                <div className="row">
                                    {SUPPORTED_LANGUAGES.map(lang => (
                                        <div key={lang.code} className="col-6 mb-3">
                                            <Form.Group>
                                                <Form.Label className="mb-2" style={{
                                                    // color: enabledLanguages[lang.code] ? '#4A5568' : '#9CA3AF',
                                                    color: '#9CA3AF',
                                                    fontWeight: '500',
                                                    fontSize: '14px'
                                                }}>
                                                    {lang.name} Description
                                                    {((formData.artifactType === 'long videos' || formData.artifactType === 'shorts or reels') || enabledLanguages[lang.code]) &&
                                                        <span className="text-danger">*</span>
                                                    }
                                                </Form.Label>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        as="textarea"
                                                        name={lang.descField}
                                                        placeholder={`Enter Description in ${lang.name}`}
                                                        value={descriptionByLanguage[lang.code] || ''}
                                                        // disabled={!enabledLanguages[lang.code]}  
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            if (value.length > 300) {
                                                                toast.error('Description cannot exceed 300 characters');
                                                                return;
                                                            }
                                                            setDescriptionByLanguage(prev => ({
                                                                ...prev,
                                                                [lang.code]: value
                                                            }));
                                                        }}
                                                        style={{
                                                            height: '100px',
                                                            border: '1px solid #E2E8F0',
                                                            backgroundColor: '#FFFFFF',
                                                            resize: 'none',
                                                        }}
                                                    />
                                                    <div
                                                        className="position-absolute"
                                                        style={{
                                                            bottom: '8px',
                                                            right: '15px',
                                                            fontSize: '12px',
                                                            color: '#6B7280'
                                                        }}
                                                    >
                                                        {(descriptionByLanguage[lang.code] || '').length}/300
                                                    </div>
                                                </div>
                                            </Form.Group>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Conditional Content Based on Artifact Type */}
                        {formData.artifactType === 'text literature' ? (
                            /* Text Literature: Show Multilingual Editor or Ebook R2 Links */
                            <>
                                {formData.category === 'EBOOKS' ? (
                                    /* Ebooks: Show R2 link inputs per enabled language */
                                    <div className="row mb-4 mt-4">
                                        {SUPPORTED_LANGUAGES.filter(lang => enabledLanguages[lang.code]).map(lang => (
                                            <div key={lang.code} className="col-3 pe-2 mb-3">
                                                <Form.Group>
                                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                        {lang.name} PDF Link <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Paste R2 link for ${lang.name}`}
                                                        value={currentMediaByLanguage[lang.code]?.main_url || ''}
                                                        onChange={(e) => setCurrentMediaByLanguage(prev => ({
                                                            ...prev,
                                                            [lang.code]: { ...prev[lang.code], main_url: e.target.value }
                                                        }))}
                                                        style={{
                                                            height: '44px',
                                                            border: '1px solid #E2E8F0',
                                                            backgroundColor: '#FFFFFF'
                                                        }}
                                                    />
                                                </Form.Group>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    /* Other text literature: Show Multilingual Editor */
                                    <div className="row mb-4">
                                        <div className="col-12">
                                            <Form.Group>
                                                <div className="d-flex justify-content-between align-items-center mt-4 mb-2">
                                                    <Form.Label style={{ color: '#4A5568', fontWeight: '500' }}>
                                                        Text Literature <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Button
                                                        variant="outline-primary"
                                                        size="sm"
                                                        onClick={() => setShowPreview(true)}
                                                        style={{ fontSize: '12px' }}
                                                    >
                                                        Preview
                                                    </Button>
                                                </div>
                                                <div className="mb-2">
                                                    <div className="d-flex gap-1" style={{ flexWrap: 'wrap' }}>
                                                        {SUPPORTED_LANGUAGES.map(lang => (
                                                            <button
                                                                key={lang.code}
                                                                type="button"
                                                                className={`btn btn-sm ${activeContentTab === lang.code ? 'btn-primary' : 'btn-outline-secondary'}`}
                                                                onClick={() => setActiveContentTab(lang.code)}
                                                                disabled={!enabledLanguages[lang.code]}
                                                                style={{
                                                                    fontSize: '12px',
                                                                    padding: '6px 12px',
                                                                    minWidth: '80px'
                                                                }}
                                                            >
                                                                {lang.name}
                                                                {contentByLanguage[lang.code]?.trim() && (
                                                                    <span style={{ color: 'green', marginLeft: '4px' }}>•</span>
                                                                )}
                                                            </button>
                                                        ))}
                                                    </div>
                                                </div>
                                                <SunEditor
                                                    key={activeContentTab}
                                                    setContents={contentByLanguage[activeContentTab]}
                                                    onChange={(content) => {
                                                        setContentByLanguage(prev => ({
                                                            ...prev,
                                                            [activeContentTab]: content
                                                        }));
                                                        if (activeContentTab === 'en') {
                                                            setHtmlContent(content);
                                                        }
                                                    }}
                                                    setOptions={{
                                                        ...sunEditorOptions,
                                                        resizingBar: false,
                                                        showPathLabel: false,
                                                        mode: 'classic'
                                                    }}
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                )}

                                {/* Thumbnail Upload Only */}
                                <div className="row mb-4">
                                    <div className="col-3">
                                        <Form.Group>
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                Upload Thumbnail <span className="text-danger">*</span>
                                            </Form.Label>
                                            <input
                                                type="file"
                                                id="thumbnailFile"
                                                onChange={(e) => handleFileChange(e, 'thumbnail')}
                                                style={{ display: 'none' }}
                                            />
                                            <div
                                                className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                                style={{
                                                    height: '150px',
                                                    backgroundColor: '#FFFFFF',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => triggerFileInput('thumbnailFile')}
                                            >
                                                {renderFilePreview(files.thumbnail, 'thumbnail')}
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                            </>
                        ) : (
                            /* Other Artifact Types: Show Multilingual Upload */
                            <div className="row mb-4 mt-4">
                                {SUPPORTED_LANGUAGES.map(lang => {
                                    const isYoutube = (formData.artifactType === 'long videos' || formData.artifactType === 'shorts or reels') && videoSource === 'YOUTUBE';
                                    if (isYoutube) {
                                        const url = youtubeUrlByLanguage[lang.code] || '';
                                        const isInvalid = enabledLanguages[lang.code] && url.trim() && !YOUTUBE_URL_REGEX.test(url.trim());
                                        return (
                                            <div key={lang.code} className="col-3 pe-2">
                                                <Form.Group>
                                                    <Form.Label className="mb-2" style={{ color: enabledLanguages[lang.code] ? '#4A5568' : '#9CA3AF', fontWeight: '500' }}>
                                                        {lang.name} YouTube URL {enabledLanguages[lang.code] && <span className="text-danger">*</span>}
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder={`Paste YouTube URL for ${lang.name}`}
                                                        value={url}
                                                        disabled={!enabledLanguages[lang.code]}
                                                        onChange={(e) => setYoutubeUrlByLanguage(prev => ({
                                                            ...prev,
                                                            [lang.code]: e.target.value
                                                        }))}
                                                        isInvalid={isInvalid}
                                                        style={{
                                                            height: '44px',
                                                            border: isInvalid ? '1px solid #DC2626' : '1px solid #E2E8F0',
                                                            backgroundColor: enabledLanguages[lang.code] ? '#FFFFFF' : '#F7FAFC'
                                                        }}
                                                    />
                                                    {isInvalid && (
                                                        <div style={{ fontSize: '11px', color: '#DC2626', marginTop: '4px' }}>
                                                            Enter a valid YouTube URL
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            </div>
                                        );
                                    }
                                    return (
                                    <div key={lang.code} className="col-3 pe-2">
                                        <Form.Group>
                                            <Form.Label className="mb-2" style={{ color: enabledLanguages[lang.code] ? '#4A5568' : '#9CA3AF', fontWeight: '500' }}>
                                                {/* {lang.name} Upload {lang.code === 'en' && <span className="text-danger">*</span>} */}
                                                {/* {filesByLanguage[lang.code]?.main && (
                                                    <span style={{ color: 'green', marginLeft: '4px' }}>•</span>
                                                )} */}
                                                {lang.name} Upload {enabledLanguages[lang.code] && <span className="text-danger">*</span>}
                                            </Form.Label>
                                            <input
                                                type="file"
                                                id={`mainFile_${lang.code}`}
                                                onChange={(e) => handleMultilingualFileChange(e, 'main', lang.code)}
                                                style={{ display: 'none' }}
                                            />
                                            {/* <div
                                                className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                                style={{
                                                    height: '150px',
                                                    backgroundColor: '#FFFFFF',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => triggerFileInput(`mainFile_${lang.code}`)} */}
                                            <div
                                                className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                                style={{
                                                    height: '150px',
                                                    backgroundColor: enabledLanguages[lang.code] ? '#FFFFFF' : '#F7FAFC',  // ← CHANGED
                                                    cursor: enabledLanguages[lang.code] ? 'pointer' : 'not-allowed',  // ← CHANGED
                                                    opacity: enabledLanguages[lang.code] ? 1 : 0.5  // ← ADDED
                                                }}
                                                onClick={() => enabledLanguages[lang.code] && triggerFileInput(`mainFile_${lang.code}`)}  // ← CHANGED
                                            >
                                                {renderMultilingualFilePreview(filesByLanguage[lang.code]?.main, 'main', lang.code)}
                                            </div>
                                        </Form.Group>
                                    </div>
                                    );
                                })}
                                <div className="col-3 ps-2">
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Upload Thumbnail <span className="text-danger">*</span>
                                        </Form.Label>
                                        <input
                                            type="file"
                                            id="thumbnailFile"
                                            onChange={(e) => handleFileChange(e, 'thumbnail')}
                                            style={{ display: 'none' }}
                                        />
                                        <div
                                            className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                            style={{
                                                height: '150px',
                                                backgroundColor: '#FFFFFF',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => triggerFileInput('thumbnailFile')}
                                        >
                                            {renderFilePreview(files.thumbnail, 'thumbnail')}
                                        </div>
                                    </Form.Group>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Additional Details Section */}
                    <div className="mb-4">
                        <h6 className="text-primary mb-4" style={{ fontSize: '16px', color: '#6366F1' }}>Additional Details</h6>

                        {/* First row: Related Waypoints, Author/Speaker, Language */}
                        <div className="row mb-3 align-items-center">
                            <div className="col-12">
                                <div className="row">
                                    {/* Has Container Checkbox */}
                                    {formData.artifactType === 'text literature' && formData.category === 'MANTRAS' && (
                                        <div className="col-3">
                                            <Form.Group>
                                                <Form.Check
                                                    type="checkbox"
                                                    id="hasContainer"
                                                    label="Has a Container"
                                                    checked={hasContainer}
                                                    onChange={handleContainerCheckboxChange}
                                                    style={{
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        color: '#4A5568'
                                                    }}
                                                />
                                            </Form.Group>
                                        </div>
                                    )}
                                    {/* Has Read Checkbox */}
                                    {(formData.artifactType === 'long videos' || formData.artifactType === 'audio or orals') && <div className="col-3">
                                        <Form.Group>
                                            <Form.Check
                                                type="checkbox"
                                                id="hasContainer"
                                                label="Has Read Artifact"
                                                checked={readFlag}
                                                onChange={(e) => { setReadFlag(e.target.checked); if (!e.target.checked) setReadSearch(''); }}
                                                style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    color: '#4A5568'
                                                }}
                                            />
                                        </Form.Group>
                                    </div>}
                                    {/* Has Listen Checkbox */}
                                    {(formData.artifactType === 'text literature' || formData.artifactType === 'long videos') && <div className="col-3">
                                        <Form.Group>
                                            <Form.Check
                                                type="checkbox"
                                                id="hasContainer"
                                                label="Has Listen Artifact"
                                                checked={listenFlag}
                                                onChange={(e) => { setListenFlag(e.target.checked); if (!e.target.checked) setListenSearch(''); }}
                                                style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    color: '#4A5568'
                                                }}
                                            />
                                        </Form.Group>
                                    </div>}
                                    {/* Has Watch Checkbox */}
                                    {(formData.artifactType === 'text literature' || formData.artifactType === 'audio or orals') && <div className="col-3">
                                        <Form.Group>
                                            <Form.Check
                                                type="checkbox"
                                                id="hasContainer"
                                                label="Has Watch Artifact"
                                                checked={watchFlag}
                                                onChange={(e) => { setWatchFlag(e.target.checked); if (!e.target.checked) setWatchSearch(''); }}
                                                style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    color: '#4A5568'
                                                }}
                                            />
                                        </Form.Group>
                                    </div>}


                                </div>
                            </div>

                            {/* Author/Speaker */}
                            {/* <div className="col-3" ref={authorInputContainerRef} style={{ position: 'relative' }}>
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        {formData.artifactType === 'TEXT_LITERATURE' ? 'Author' : 'Author/Speaker'} <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="author"
                                        placeholder={`Enter ${formData.artifactType === 'TEXT_LITERATURE' ? 'Author' : 'Author/Speaker'}`}
                                        value={formData.author || ''}
                                        onChange={handleInputChange}
                                        onFocus={handleAuthorInputFocus}
                                        onBlur={handleAuthorInputBlur}
                                        autoComplete="off" 
                                        style={{
                                            height: '44px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF'
                                        }}
                                    />
                                    {authorsError && (
                                        <div className="position-absolute mt-1 p-2 bg-white border rounded shadow-sm w-100 text-danger" style={{ zIndex: 1000 }}>
                                            Error: {authorsError}
                                        </div>
                                    )}
                                    
                                    {showAuthorSuggestions && !authorsError && (
                                        <div
                                            className="position-absolute mt-1 bg-white border rounded shadow-sm w-100"
                                            style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 1000 }}
                                        >
                                            {filteredAuthors.length > 0 ? (
                                                <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                                                    {filteredAuthors.map((author, index) => (
                                                        <li
                                                            key={index} 
                                                            onClick={() => handleAuthorSelect(author)}
                                                            style={{
                                                                padding: '8px 12px',
                                                                cursor: 'pointer',
                                                                borderBottom: '1px solid #eee'
                                                            }}
                                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                                        >
                                                            {author}
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <div style={{ padding: '8px 12px', color: '#666' }}>
                                                    No matching authors. You can add "{formData.author}"
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </Form.Group>
                            </div> */}

                            {/* Language */}
                            {/* <div className="col-3">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Language <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Select
                                        name="languages"
                                        value={formData.languages || ''}
                                        onChange={handleInputChange}
                                        style={{
                                            height: '44px',
                                            border: '1px solid #E2E8F0',
                                            backgroundColor: '#FFFFFF'
                                        }}
                                    >
                                        <option value="" hidden>Select Language</option>
                                        <option value="english">English</option>
                                        <option value="hindi">Hindi</option>
                                        <option value="marathi">Marathi</option>
                                        <option value="gujarati">Gujarati</option>
                                        <option value="sanskrit">Sanskrit</option>
                                    </Form.Select>
                                </Form.Group>
                            </div> */}
                        </div>

                        <div className="row mb-3">

{readFlag && (
    <div className="row mb-3">
        <div className="col-3">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Select Read Artifact <span className="text-danger">*</span>
                </Form.Label>
                <div className="position-relative">
                    <Form.Control
                        type="text"
                        placeholder="Search Read Artifact"
                        value={readSearch}
                        onChange={(e) => setReadSearch(e.target.value)}
                        style={{ height: '44px', paddingRight: '35px', border: '1px solid #E2E8F0' }}
                    />
                    <img src={Search} alt="search" className="position-absolute"
                        style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', zIndex: 2 }}
                    />
                    {readSearch.length > 0 && (
                        <div className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                            {allReadArtifacts
                                .filter(a => a.title?.toLowerCase().includes(readSearch.toLowerCase()))
                                .map(artifact => (
                                    <div key={artifact.artifact_id} className="p-2"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setSelectedReadId(artifact.artifact_id);
                                            setSelectedReadArtifact(artifact);
                                            setReadSearch('');
                                        }}
                                    >
                                        {artifact.title}
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>
            </Form.Group>
        </div>
        <div className="col-6">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Selected Read Artifact
                </Form.Label>
                <div style={{ minHeight: '44px', border: '1px solid #E2E8F0', borderRadius: '0.375rem', padding: '8px 12px', backgroundColor: '#FFFFFF' }}>
                    {selectedReadArtifact && (
                        <span className="d-inline-flex align-items-center"
                            style={{ backgroundColor: '#6366F1', color: 'white', padding: '4px 10px', borderRadius: '6px', fontSize: '14px' }}
                        >
                            {selectedReadArtifact.title}
                            <button onClick={(e) => { e.preventDefault(); setSelectedReadId(''); setSelectedReadArtifact(null); }}
                                className="ms-2 border-0 bg-transparent text-white" style={{ cursor: 'pointer', fontSize: '16px', lineHeight: 1 }}>
                                ×
                            </button>
                        </span>
                    )}
                </div>
            </Form.Group>
        </div>
    </div>
)}


{listenFlag && (
    <div className="row mb-3">
        {/* Search Listen */}
        <div className="col-3">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Select Listen Artifact <span className="text-danger">*</span>
                </Form.Label>
                <div className="position-relative">
                    <Form.Control
                        type="text"
                        placeholder="Search Listen Artifact"
                        value={listenSearch}
                        onChange={(e) => setListenSearch(e.target.value)}
                        style={{ height: '44px', paddingRight: '35px', border: '1px solid #E2E8F0' }}
                    />
                    <img src={Search} alt="search" className="position-absolute"
                        style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', zIndex: 2 }}
                    />
                    {listenSearch.length > 0 && (
                        <div className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                            {allListenArtifacts
                                .filter(a => a.title?.toLowerCase().includes(listenSearch.toLowerCase()))
                                .map(artifact => (
                                    <div key={artifact.artifact_id} className="p-2"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setSelectedListenId(artifact.artifact_id);
                                            setSelectedListenArtifact(artifact);
                                            setListenSearch('');
                                        }}
                                    >
                                        {artifact.title}
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>
            </Form.Group>
        </div>

        {/* Selected Listen */}
        <div className="col-6">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Selected Listen Artifact
                </Form.Label>
                <div style={{ minHeight: '44px', border: '1px solid #E2E8F0', borderRadius: '0.375rem', padding: '8px 12px', backgroundColor: '#FFFFFF' }}>
                    {selectedListenArtifact && (
                        <span className="d-inline-flex align-items-center"
                            style={{ backgroundColor: '#6366F1', color: 'white', padding: '4px 10px', borderRadius: '6px', fontSize: '14px' }}
                        >
                            {selectedListenArtifact.title}
                            <button onClick={(e) => { e.preventDefault(); setSelectedListenId(''); setSelectedListenArtifact(null); }}
                                className="ms-2 border-0 bg-transparent text-white" style={{ cursor: 'pointer', fontSize: '16px', lineHeight: 1 }}>
                                ×
                            </button>
                        </span>
                    )}
                </div>
            </Form.Group>
        </div>
    </div>
)}

{watchFlag && (
    <div className="row mb-3">
        {/* Search Watch */}
        <div className="col-3">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Select Watch Artifact <span className="text-danger">*</span>
                </Form.Label>
                <div className="position-relative">
                    <Form.Control
                        type="text"
                        placeholder="Search Watch Artifact"
                        value={watchSearch}
                        onChange={(e) => setWatchSearch(e.target.value)}
                        style={{ height: '44px', paddingRight: '35px', border: '1px solid #E2E8F0' }}
                    />
                    <img src={Search} alt="search" className="position-absolute"
                        style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', zIndex: 2 }}
                    />
                    {watchSearch.length > 0 && (
                        <div className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}>
                            {allWatchArtifacts
                                .filter(a => a.title?.toLowerCase().includes(watchSearch.toLowerCase()))
                                .map(artifact => (
                                    <div key={artifact.artifact_id} className="p-2"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setSelectedWatchId(artifact.artifact_id);
                                            setSelectedWatchArtifact(artifact);
                                            setWatchSearch('');
                                        }}
                                    >
                                        {artifact.title}
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>
            </Form.Group>
        </div>

        {/* Selected Watch */}
        <div className="col-6">
            <Form.Group>
                <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                    Selected Watch Artifact
                </Form.Label>
                <div style={{ minHeight: '44px', border: '1px solid #E2E8F0', borderRadius: '0.375rem', padding: '8px 12px', backgroundColor: '#FFFFFF' }}>
                    {selectedWatchArtifact && (
                        <span className="d-inline-flex align-items-center"
                            style={{ backgroundColor: '#6366F1', color: 'white', padding: '4px 10px', borderRadius: '6px', fontSize: '14px' }}
                        >
                            {selectedWatchArtifact.title}
                            <button onClick={(e) => { e.preventDefault(); setSelectedWatchId(''); setSelectedWatchArtifact(null); }}
                                className="ms-2 border-0 bg-transparent text-white" style={{ cursor: 'pointer', fontSize: '16px', lineHeight: 1 }}>
                                ×
                            </button>
                        </span>
                    )}
                </div>
            </Form.Group>
        </div>
    </div>
)}

                        </div>


                        {/* Container Section - Show only for Text Literature + Mantras */}
                        {formData.artifactType === 'text literature' && formData.category === 'MANTRAS' && (
                            <>
                                {/* Container Options - Show when checkbox is checked */}
                                {hasContainer && (
                                    <div className="row mb-3">
                                        {/* Radio Buttons */}
                                        <div className="col-12 mb-3">
                                            <Form.Group>
                                                <div className="d-flex gap-4">
                                                    <Form.Check
                                                        type="radio"
                                                        id="containerExisting"
                                                        name="containerOption"
                                                        value="EXISTING"
                                                        label="Existing Container"
                                                        checked={containerOption === 'EXISTING'}
                                                        onChange={handleContainerOptionChange}
                                                        style={{ fontSize: '14px', fontWeight: '500' }}
                                                    />
                                                    <Form.Check
                                                        type="radio"
                                                        id="containerNew"
                                                        name="containerOption"
                                                        value="NEW"
                                                        label="New Container"
                                                        checked={containerOption === 'NEW'}
                                                        onChange={handleContainerOptionChange}
                                                        style={{ fontSize: '14px', fontWeight: '500' }}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </div>
                                        {/* Existing Container Multi-Select */}
                                        {containerOption === 'EXISTING' && (
                                            <>
                                                {/* Search Container */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Search Containers <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <div className="position-relative">
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Search Containers"
                                                                value={searchContainer}
                                                                onChange={(e) => setSearchContainer(e.target.value)}
                                                                style={{
                                                                    height: '44px',
                                                                    paddingRight: '35px',
                                                                    paddingLeft: '12px',
                                                                    border: '1px solid #E2E8F0',
                                                                    backgroundColor: '#FFFFFF'
                                                                }}
                                                            />
                                                            <img
                                                                src={Search}
                                                                alt="search"
                                                                className="position-absolute"
                                                                style={{
                                                                    right: '10px',
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    width: '16px',
                                                                    height: '16px',
                                                                    zIndex: 2
                                                                }}
                                                            />
                                                            {/* Container Search Results Dropdown */}
                                                            {searchContainer.length > 0 && allContainers.filter((container) =>
                                                                container?.container_name?.toLowerCase().includes(searchContainer.toLowerCase())
                                                            ).length > 0 && (
                                                                    <div
                                                                        className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                                        style={{
                                                                            zIndex: 1000,
                                                                            maxHeight: '200px',
                                                                            overflowY: 'auto'
                                                                        }}
                                                                    >
                                                                        {allContainers.filter((container) =>
                                                                            container?.container_name?.toLowerCase().includes(searchContainer.toLowerCase())
                                                                        ).map(container => {
                                                                            const isSelected = selectedContainers.some(c => c.container_id === container.container_id);
                                                                            if (!isSelected) {
                                                                                return (
                                                                                    <div
                                                                                        key={container.container_id}
                                                                                        className="p-2 cursor-pointer hover:bg-gray-100 d-flex align-items-center gap-2"
                                                                                        onClick={() => handleContainerSelect(container)}
                                                                                        style={{ cursor: 'pointer' }}
                                                                                    >
                                                                                        {container.container_thumbnail_url && (
                                                                                            <img
                                                                                                src={container.container_thumbnail_url}
                                                                                                alt=""
                                                                                                style={{
                                                                                                    width: '30px',
                                                                                                    height: '30px',
                                                                                                    objectFit: 'cover',
                                                                                                    borderRadius: '4px'
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                        {container.container_name}
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            return null;
                                                                        })}
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                                {/* Selected Containers */}
                                                <div className="col-6">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Selected Containers
                                                        </Form.Label>
                                                        <div className="position-relative">
                                                            <div
                                                                style={{
                                                                    minHeight: '100px',
                                                                    maxHeight: '100px',
                                                                    height: 'auto',
                                                                    border: '1px solid #E2E8F0',
                                                                    backgroundColor: '#FFFFFF',
                                                                    borderRadius: '0.375rem',
                                                                    padding: '12px',
                                                                    overflowY: 'auto',
                                                                }}
                                                            >
                                                                <div className="d-flex flex-wrap gap-2">
                                                                    {selectedContainers.map((container) => (
                                                                        <span
                                                                            key={container.container_id}
                                                                            className="d-inline-flex align-items-center"
                                                                            style={{
                                                                                backgroundColor: '#6366F1',
                                                                                color: 'white',
                                                                                padding: '6px 12px',
                                                                                borderRadius: '6px',
                                                                                fontSize: '14px',
                                                                                marginBottom: '4px'
                                                                            }}
                                                                        >
                                                                            {container.container_name}
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    handleContainerRemove(container.container_id);
                                                                                }}
                                                                                className="ms-2 border-0 bg-transparent text-white"
                                                                                style={{
                                                                                    padding: '0',
                                                                                    lineHeight: 1,
                                                                                    fontSize: '18px',
                                                                                    fontWeight: 'bold',
                                                                                    opacity: 0.8,
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            >
                                                                                ×
                                                                            </button>
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )}
                                        {/* New Container Fields */}
                                        {containerOption === 'NEW' && (
                                            <>
                                                {/* Container Name (English) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (English) <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Container Name"
                                                            value={newContainerName}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Only allow letters and spaces
                                                                if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 255) {
                                                                    setNewContainerName(value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Hindi) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Hindi)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="कंटेनर नाम दर्ज करें"
                                                            value={newContainerNameHin}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameHin(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Marathi) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Marathi)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="कंटेनर नाव प्रविष्ट करा"
                                                            value={newContainerNameMar}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameMar(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Gujarati) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Gujarati)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="કન્ટેનર નામ દાખલ કરો"
                                                            value={newContainerNameGuj}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameGuj(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Thumbnail Upload */}
                                                <div className="col-3 mt-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Thumbnail <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <input
                                                            type="file"
                                                            id="containerThumbnailFile"
                                                            accept=".jpg,.jpeg,.png,.gif"
                                                            onChange={handleContainerThumbnailChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <div
                                                            className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                                            style={{
                                                                height: '100px',
                                                                backgroundColor: '#FFFFFF',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() => document.getElementById('containerThumbnailFile').click()}
                                                        >
                                                            {containerThumbnail ? (
                                                                <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                                                                    <img
                                                                        src={URL.createObjectURL(containerThumbnail)}
                                                                        alt="Container Thumbnail"
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'cover',
                                                                            borderRadius: '8px'
                                                                        }}
                                                                    />
                                                                    <div style={{
                                                                        position: 'absolute',
                                                                        bottom: '0',
                                                                        left: '0',
                                                                        right: '0',
                                                                        padding: '4px',
                                                                        background: 'rgba(0, 0, 0, 0.6)',
                                                                        color: 'white',
                                                                        fontSize: '10px',
                                                                        textAlign: 'center'
                                                                    }}>
                                                                        {containerThumbnail.name}
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="text-center">
                                                                    <span style={{ fontSize: '24px', color: '#A0AEC0' }}>+</span>
                                                                    <p style={{ fontSize: '10px', color: '#718096', margin: '0' }}>
                                                                        Upload JPG, PNG, GIF<br />(Max 3MB)
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                        {/* Listen Container Section - Show only for Audio + Mantras and chants */}
                        {formData.artifactType === 'audio or orals' && formData.category === 'MANTRAS_CHANTS' && (
                            <>
                                {/* Has Container Checkbox */}
                                <div className="row mb-3">
                                    <div className="col-12">
                                        <Form.Group>
                                            <Form.Check
                                                type="checkbox"
                                                id="hasContainer"
                                                label="Has a Container"
                                                checked={hasContainer}
                                                onChange={handleContainerCheckboxChange}
                                                style={{
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    color: '#4A5568'
                                                }}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                                {/* Container Options - Show when checkbox is checked */}
                                {hasContainer && (
                                    <div className="row mb-3">
                                        {/* Radio Buttons */}
                                        <div className="col-12 mb-3">
                                            <Form.Group>
                                                <div className="d-flex gap-4">
                                                    <Form.Check
                                                        type="radio"
                                                        id="containerExisting"
                                                        name="containerOption"
                                                        value="EXISTING"
                                                        label="Existing Container"
                                                        checked={containerOption === 'EXISTING'}
                                                        onChange={handleContainerOptionChange}
                                                        style={{ fontSize: '14px', fontWeight: '500' }}
                                                    />
                                                    <Form.Check
                                                        type="radio"
                                                        id="containerNew"
                                                        name="containerOption"
                                                        value="NEW"
                                                        label="New Container"
                                                        checked={containerOption === 'NEW'}
                                                        onChange={handleContainerOptionChange}
                                                        style={{ fontSize: '14px', fontWeight: '500' }}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </div>
                                        {/* Existing Container Multi-Select */}
                                        {containerOption === 'EXISTING' && (
                                            <>
                                                {/* Search Container */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Search Containers <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <div className="position-relative">
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Search Containers"
                                                                value={searchContainer}
                                                                onChange={(e) => setSearchContainer(e.target.value)}
                                                                style={{
                                                                    height: '44px',
                                                                    paddingRight: '35px',
                                                                    paddingLeft: '12px',
                                                                    border: '1px solid #E2E8F0',
                                                                    backgroundColor: '#FFFFFF'
                                                                }}
                                                            />
                                                            <img
                                                                src={Search}
                                                                alt="search"
                                                                className="position-absolute"
                                                                style={{
                                                                    right: '10px',
                                                                    top: '50%',
                                                                    transform: 'translateY(-50%)',
                                                                    width: '16px',
                                                                    height: '16px',
                                                                    zIndex: 2
                                                                }}
                                                            />
                                                            {/* Container Search Results Dropdown */}
                                                            {searchContainer.length > 0 && allListenContainers.filter((container) =>
                                                                container?.container_name?.toLowerCase().includes(searchContainer.toLowerCase())
                                                            ).length > 0 && (
                                                                    <div
                                                                        className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                                        style={{
                                                                            zIndex: 1000,
                                                                            maxHeight: '200px',
                                                                            overflowY: 'auto'
                                                                        }}
                                                                    >
                                                                        {allListenContainers.filter((container) =>
                                                                            container?.container_name?.toLowerCase().includes(searchContainer.toLowerCase())
                                                                        ).map(container => {
                                                                            const isSelected = selectedListenContainers.some(c => c.container_id === container.container_id);
                                                                            if (!isSelected) {
                                                                                return (
                                                                                    <div
                                                                                        key={container.container_id}
                                                                                        className="p-2 cursor-pointer hover:bg-gray-100 d-flex align-items-center gap-2"
                                                                                        onClick={() => handleListenContainerSelect(container)}
                                                                                        style={{ cursor: 'pointer' }}
                                                                                    >
                                                                                        {container.container_thumbnail_url && (
                                                                                            <img
                                                                                                src={container.container_thumbnail_url}
                                                                                                alt=""
                                                                                                style={{
                                                                                                    width: '30px',
                                                                                                    height: '30px',
                                                                                                    objectFit: 'cover',
                                                                                                    borderRadius: '4px'
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                        {container.container_name}
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            return null;
                                                                        })}
                                                                    </div>
                                                                )}
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                                {/* Selected Containers */}
                                                <div className="col-6">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Selected Containers
                                                        </Form.Label>
                                                        <div className="position-relative">
                                                            <div
                                                                style={{
                                                                    minHeight: '100px',
                                                                    maxHeight: '100px',
                                                                    height: 'auto',
                                                                    border: '1px solid #E2E8F0',
                                                                    backgroundColor: '#FFFFFF',
                                                                    borderRadius: '0.375rem',
                                                                    padding: '12px',
                                                                    overflowY: 'auto',
                                                                }}
                                                            >
                                                                <div className="d-flex flex-wrap gap-2">
                                                                    {selectedListenContainers.map((container) => (
                                                                        <span
                                                                            key={container.container_id}
                                                                            className="d-inline-flex align-items-center"
                                                                            style={{
                                                                                backgroundColor: '#6366F1',
                                                                                color: 'white',
                                                                                padding: '6px 12px',
                                                                                borderRadius: '6px',
                                                                                fontSize: '14px',
                                                                                marginBottom: '4px'
                                                                            }}
                                                                        >
                                                                            {container.container_name}
                                                                            <button
                                                                                onClick={(e) => {
                                                                                    e.preventDefault();
                                                                                    handleListenContainerRemove(container.container_id);
                                                                                }}
                                                                                className="ms-2 border-0 bg-transparent text-white"
                                                                                style={{
                                                                                    padding: '0',
                                                                                    lineHeight: 1,
                                                                                    fontSize: '18px',
                                                                                    fontWeight: 'bold',
                                                                                    opacity: 0.8,
                                                                                    cursor: 'pointer'
                                                                                }}
                                                                            >
                                                                                ×
                                                                            </button>
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )}
                                        {/* New Container Fields */}
                                        {containerOption === 'NEW' && (
                                            <>
                                                {/* Container Name (English) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (English) <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter Container Name"
                                                            value={newContainerName}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Only allow letters and spaces
                                                                if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 255) {
                                                                    setNewContainerName(value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Hindi) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Hindi)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="कंटेनर नाम दर्ज करें"
                                                            value={newContainerNameHin}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameHin(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Marathi) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Marathi)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="कंटेनर नाव प्रविष्ट करा"
                                                            value={newContainerNameMar}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameMar(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Name (Gujarati) */}
                                                <div className="col-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Name (Gujarati)
                                                        </Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="કન્ટેનર નામ દાખલ કરો"
                                                            value={newContainerNameGuj}
                                                            onChange={(e) => {
                                                                if (e.target.value.length <= 255) {
                                                                    setNewContainerNameGuj(e.target.value);
                                                                }
                                                            }}
                                                            style={{
                                                                height: '44px',
                                                                border: '1px solid #E2E8F0',
                                                                backgroundColor: '#FFFFFF'
                                                            }}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* Container Thumbnail Upload */}
                                                <div className="col-3 mt-3">
                                                    <Form.Group>
                                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                            Container Thumbnail <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <input
                                                            type="file"
                                                            id="containerThumbnailFile"
                                                            accept=".jpg,.jpeg,.png,.gif"
                                                            onChange={handleContainerThumbnailChange}
                                                            style={{ display: 'none' }}
                                                        />
                                                        <div
                                                            className="border border-2 border-dashed rounded d-flex align-items-center justify-content-center"
                                                            style={{
                                                                height: '100px',
                                                                backgroundColor: '#FFFFFF',
                                                                cursor: 'pointer'
                                                            }}
                                                            onClick={() => document.getElementById('containerThumbnailFile').click()}
                                                        >
                                                            {containerThumbnail ? (
                                                                <div className="position-relative" style={{ width: '100%', height: '100%' }}>
                                                                    <img
                                                                        src={URL.createObjectURL(containerThumbnail)}
                                                                        alt="Container Thumbnail"
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            objectFit: 'cover',
                                                                            borderRadius: '8px'
                                                                        }}
                                                                    />
                                                                    <div style={{
                                                                        position: 'absolute',
                                                                        bottom: '0',
                                                                        left: '0',
                                                                        right: '0',
                                                                        padding: '4px',
                                                                        background: 'rgba(0, 0, 0, 0.6)',
                                                                        color: 'white',
                                                                        fontSize: '10px',
                                                                        textAlign: 'center'
                                                                    }}>
                                                                        {containerThumbnail.name}
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="text-center">
                                                                    <span style={{ fontSize: '24px', color: '#A0AEC0' }}>+</span>
                                                                    <p style={{ fontSize: '10px', color: '#718096', margin: '0' }}>
                                                                        Upload JPG, PNG, GIF<br />(Max 3MB)
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </Form.Group>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                            </>
                        )}

                        {/* Second Row: Selected Waypoints and Selected Deities */}
                        <div className="row mb-3">




                            <div className="row mb-3">
                                {/* Related Parikramas */}
                                <div className="col-3">
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Related Parikramas
                                        </Form.Label>
                                        <div className="position-relative">
                                            <Form.Control
                                                type="text"
                                                name="relatedDeity"
                                                placeholder="Search Related Parikramas"
                                                value={searchJourney}
                                                onChange={(item) => {
                                                    setSearchJourney(item.target.value)
                                                }}
                                                style={{
                                                    height: '44px',
                                                    paddingRight: '35px',
                                                    paddingLeft: '12px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF'
                                                }}
                                            />
                                            <img
                                                src={Search}
                                                alt="search"
                                                className="position-absolute"
                                                style={{
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    width: '16px',
                                                    height: '16px',
                                                    zIndex: 2
                                                }}
                                            />
                                            {/* Deity Search Results Dropdown */}
                                            {searchJourney.length > 0 && journeyResults.length > 0 && journeyResults.filter((journey) => journey?.trip_name?.toLowerCase().includes(searchJourney.toLowerCase())).length > 0 && (
                                                <div
                                                    className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                    style={{
                                                        zIndex: 1000,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto'
                                                    }}
                                                >
                                                    {journeyResults.length > 0 && journeyResults.filter((journey) => journey?.trip_name?.toLowerCase().includes(searchJourney.toLowerCase())).map(journey => {
                                                        const isSelected = selectedJourneys.some(j => j.journey_id === journey.journey_id);
                                                        if (!isSelected) {
                                                            return (
                                                                <div
                                                                    key={journey.journey_id}
                                                                    className="p-2 cursor-pointer hover:bg-gray-100"
                                                                    onClick={() => handleJourneySelect(journey)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    {journey.trip_name}
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    </Form.Group>
                                </div>

                                {/* Selected Journeys */}
                                <div className="col-6">
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Selected Parikramas
                                        </Form.Label>
                                        <div className="position-relative">
                                            <div
                                                style={{
                                                    minHeight: '100px',
                                                    maxHeight: '100px',
                                                    height: 'auto',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '0.375rem',
                                                    padding: '12px',
                                                    overflowY: 'auto',
                                                }}
                                            >
                                                <div className="d-flex flex-wrap gap-2">
                                                    {selectedJourneys.map((journey) => (
                                                        <span
                                                            key={journey.journey_id}
                                                            className="d-inline-flex align-items-center"
                                                            style={{
                                                                backgroundColor: '#6366F1',
                                                                color: 'white',
                                                                padding: '6px 12px',
                                                                borderRadius: '6px',
                                                                fontSize: '14px',
                                                                marginBottom: '4px'
                                                            }}
                                                        >
                                                            {journey.trip_name}
                                                            <button
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleJourneyRemove(journey.journey_id);
                                                                }}
                                                                className="ms-2 border-0 bg-transparent text-white"
                                                                style={{
                                                                    padding: '0',
                                                                    lineHeight: 1,
                                                                    fontSize: '18px',
                                                                    fontWeight: 'bold',
                                                                    opacity: 0.8,
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                ×
                                                            </button>
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </Form.Group>
                                </div>
                            </div>

                            {/* Related Waypoints */}
                            <div className="col-3">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Related Teerthas
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            name="relatedWaypoint"
                                            placeholder="Search Related Teerthas"
                                            value={formData.relatedWaypoint}
                                            onChange={handleInputChange}
                                            style={{
                                                height: '44px',
                                                paddingRight: '35px',
                                                paddingLeft: '12px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF'
                                            }}
                                        />
                                        <img
                                            src={Search}
                                            alt="search"
                                            className="position-absolute"
                                            style={{
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: '16px',
                                                height: '16px',
                                                zIndex: 2
                                            }}
                                        />
                                        {/* Search Results Dropdown */}
                                        {waypointResults.length > 0 && (
                                            <div
                                                className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                style={{
                                                    zIndex: 1000,
                                                    maxHeight: '200px',
                                                    overflowY: 'auto'
                                                }}
                                            >
                                                {waypointResults.map(waypoint => {
                                                    const isSelected = formData.selectedWaypoints.some(w => w.wpt_id === waypoint.wpt_id);
                                                    if (!isSelected) {
                                                        return (
                                                            <div
                                                                key={waypoint.wpt_id}
                                                                className="p-2 cursor-pointer hover:bg-gray-100"
                                                                onClick={() => handleWaypointSelect(waypoint)}
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                {waypoint.wpt_name}
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </div>
                                        )}
                                    </div>
                                </Form.Group>
                            </div>
                            {/* Selected Waypoints */}
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Selected Teerthas
                                    </Form.Label>
                                    <div className="position-relative">
                                        <div
                                            style={{
                                                minHeight: '100px',
                                                maxHeight: '100px',
                                                height: 'auto',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '0.375rem',
                                                padding: '12px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            <div className="d-flex flex-wrap gap-2">
                                                {formData.selectedWaypoints.map((waypoint) => (
                                                    <span
                                                        key={waypoint.wpt_id}
                                                        className="d-inline-flex align-items-center"
                                                        style={{
                                                            backgroundColor: '#6366F1',
                                                            color: 'white',
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            fontSize: '14px',
                                                            marginBottom: '4px'
                                                        }}
                                                    >
                                                        {waypoint.wpt_name}
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleWaypointRemove(waypoint.wpt_id);
                                                            }}
                                                            className="ms-2 border-0 bg-transparent text-white"
                                                            style={{
                                                                padding: '0',
                                                                lineHeight: 1,
                                                                fontSize: '18px',
                                                                fontWeight: 'bold',
                                                                opacity: 0.8,
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>

                            <div className="row mb-3">


                                {/* Related Deities */}
                                <div className="col-3">
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Related Deities
                                        </Form.Label>
                                        <div className="position-relative">
                                            <Form.Control
                                                type="text"
                                                name="relatedDeity"
                                                placeholder="Search Related Deities"
                                                value={searchDeity}
                                                onChange={(item) => {
                                                    setSearchDeity(item.target.value)
                                                }}
                                                style={{
                                                    height: '44px',
                                                    paddingRight: '35px',
                                                    paddingLeft: '12px',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF'
                                                }}
                                            />
                                            <img
                                                src={Search}
                                                alt="search"
                                                className="position-absolute"
                                                style={{
                                                    right: '10px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    width: '16px',
                                                    height: '16px',
                                                    zIndex: 2
                                                }}
                                            />
                                            {/* Deity Search Results Dropdown */}
                                            {searchDeity.length > 0 && deityResults.length > 0 && deityResults.filter((deity) => deity?.deity_name?.toLowerCase().includes(searchDeity.toLowerCase())).length > 0 && (
                                                <div
                                                    className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                    style={{
                                                        zIndex: 1000,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto'
                                                    }}
                                                >
                                                    {deityResults.length > 0 && deityResults.filter((deity) => deity?.deity_name?.toLowerCase().includes(searchDeity.toLowerCase())).map(deity => {
                                                        const isSelected = selectedDeities.some(d => d.deity_id === deity.deity_id);
                                                        if (!isSelected) {
                                                            return (
                                                                <div
                                                                    key={deity.deity_id}
                                                                    className="p-2 cursor-pointer hover:bg-gray-100"
                                                                    onClick={() => handleDeitySelect(deity)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    {deity.deity_name}
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    </Form.Group>
                                </div>

                                {/* Selected Deities */}
                                <div className="col-6">
                                    <Form.Group>
                                        <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                            Selected Deities
                                        </Form.Label>
                                        <div className="position-relative">
                                            <div
                                                style={{
                                                    minHeight: '100px',
                                                    maxHeight: '100px',
                                                    height: 'auto',
                                                    border: '1px solid #E2E8F0',
                                                    backgroundColor: '#FFFFFF',
                                                    borderRadius: '0.375rem',
                                                    padding: '12px',
                                                    overflowY: 'auto',
                                                }}
                                            >
                                                <div className="d-flex flex-wrap gap-2">
                                                    {selectedDeities.map((deity) => (
                                                        <span
                                                            key={deity.deity_id}
                                                            className="d-inline-flex align-items-center"
                                                            style={{
                                                                backgroundColor: '#6366F1',
                                                                color: 'white',
                                                                padding: '6px 12px',
                                                                borderRadius: '6px',
                                                                fontSize: '14px',
                                                                marginBottom: '4px'
                                                            }}
                                                        >
                                                            {deity.deity_name}
                                                            <button
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleDeityRemove(deity.deity_id);
                                                                }}
                                                                className="ms-2 border-0 bg-transparent text-white"
                                                                style={{
                                                                    padding: '0',
                                                                    lineHeight: 1,
                                                                    fontSize: '18px',
                                                                    fontWeight: 'bold',
                                                                    opacity: 0.8,
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                ×
                                                            </button>
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </Form.Group>
                                </div>
                            </div>
                        </div>

                        {/* Related Saints Section */}
                        <div className="row mb-3">
                            {/* Related Saints Search */}
                            <div className="col-3">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Related Saints
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            name="relatedSaint"
                                            placeholder="Search Related Saints"
                                            value={searchSaint}
                                            onChange={(e) => setSearchSaint(e.target.value)}
                                            style={{
                                                height: '44px',
                                                paddingRight: '35px',
                                                paddingLeft: '12px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF'
                                            }}
                                        />
                                        <img
                                            src={Search}
                                            alt="search"
                                            className="position-absolute"
                                            style={{
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: '16px',
                                                height: '16px',
                                                zIndex: 2
                                            }}
                                        />
                                        {/* Saints Search Results Dropdown */}
                                        {searchSaint.length > 0 && saintResults.length > 0 && saintResults.filter((saint) =>
                                            saint?.name?.toLowerCase().includes(searchSaint.toLowerCase())
                                        ).length > 0 && (
                                                <div
                                                    className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                    style={{
                                                        zIndex: 1000,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto'
                                                    }}
                                                >
                                                    {saintResults.filter((saint) =>
                                                        saint?.name?.toLowerCase().includes(searchSaint.toLowerCase())
                                                    ).map(saint => {
                                                        const isSelected = selectedSaints.some(s => s.id === saint.id);
                                                        if (!isSelected) {
                                                            return (
                                                                <div
                                                                    key={saint.id}
                                                                    className="p-2 cursor-pointer hover:bg-gray-100"
                                                                    onClick={() => handleSaintSelect(saint)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    {saint.name}
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </div>
                                            )}
                                    </div>
                                </Form.Group>
                            </div>

                            {/* Selected Saints */}
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Selected Saints
                                    </Form.Label>
                                    <div className="position-relative">
                                        <div
                                            style={{
                                                minHeight: '100px',
                                                maxHeight: '100px',
                                                height: 'auto',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '0.375rem',
                                                padding: '12px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            <div className="d-flex flex-wrap gap-2">
                                                {selectedSaints.map((saint) => (
                                                    <span
                                                        key={saint.id}
                                                        className="d-inline-flex align-items-center"
                                                        style={{
                                                            backgroundColor: '#6366F1',
                                                            color: 'white',
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            fontSize: '14px',
                                                            marginBottom: '4px'
                                                        }}
                                                    >
                                                        {saint.name}
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleSaintRemove(saint.id);
                                                            }}
                                                            className="ms-2 border-0 bg-transparent text-white"
                                                            style={{
                                                                padding: '0',
                                                                lineHeight: 1,
                                                                fontSize: '18px',
                                                                fontWeight: 'bold',
                                                                opacity: 0.8,
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        {/* Related Projects Section */}
                        <div className="row mb-3">
                            {/* Related Projects Search */}
                            <div className="col-3">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Related Projects
                                    </Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type="text"
                                            name="relatedProject"
                                            placeholder="Search Related Projects"
                                            value={searchProject}
                                            onChange={(e) => setSearchProject(e.target.value)}
                                            style={{
                                                height: '44px',
                                                paddingRight: '35px',
                                                paddingLeft: '12px',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF'
                                            }}
                                        />
                                        <img
                                            src={Search}
                                            alt="search"
                                            className="position-absolute"
                                            style={{
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                width: '16px',
                                                height: '16px',
                                                zIndex: 2
                                            }}
                                        />
                                        {/* Projects Search Results Dropdown */}
                                        {searchProject.length > 0 && projectResults.length > 0 && projectResults.filter((project) =>
                                            project?.project_title?.toLowerCase().includes(searchProject.toLowerCase())
                                        ).length > 0 && (
                                                <div
                                                    className="position-absolute w-100 bg-white border rounded mt-1 shadow-sm"
                                                    style={{
                                                        zIndex: 1000,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto'
                                                    }}
                                                >
                                                    {projectResults.filter((project) =>
                                                        project?.project_title?.toLowerCase().includes(searchProject.toLowerCase())
                                                    ).map(project => {
                                                        const isSelected = selectedProjects.some(p => p.project_id === project.project_id);
                                                        if (!isSelected) {
                                                            return (
                                                                <div
                                                                    key={project.project_id}
                                                                    className="p-2 cursor-pointer hover:bg-gray-100"
                                                                    onClick={() => handleProjectSelect(project)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    {project.project_title}
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                </div>
                                            )}
                                    </div>
                                </Form.Group>
                            </div>

                            {/* Selected Projects */}
                            <div className="col-6">
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Selected Projects
                                    </Form.Label>
                                    <div className="position-relative">
                                        <div
                                            style={{
                                                minHeight: '100px',
                                                maxHeight: '100px',
                                                height: 'auto',
                                                border: '1px solid #E2E8F0',
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '0.375rem',
                                                padding: '12px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            <div className="d-flex flex-wrap gap-2">
                                                {selectedProjects.map((project) => (
                                                    <span
                                                        key={project.project_id}
                                                        className="d-inline-flex align-items-center"
                                                        style={{
                                                            backgroundColor: '#6366F1',
                                                            color: 'white',
                                                            padding: '6px 12px',
                                                            borderRadius: '6px',
                                                            fontSize: '14px',
                                                            marginBottom: '4px'
                                                        }}
                                                    >
                                                        {project.project_title}
                                                        <button
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleProjectRemove(project.project_id);
                                                            }}
                                                            className="ms-2 border-0 bg-transparent text-white"
                                                            style={{
                                                                padding: '0',
                                                                lineHeight: 1,
                                                                fontSize: '18px',
                                                                fontWeight: 'bold',
                                                                opacity: 0.8,
                                                                cursor: 'pointer'
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        {/* Third row: Related Deities */}


                        {/* Promote As & Subscription Type */}
                        <div className="row mb-3">
                            <div className="col-6 mt-4">
                                {/* Promote As */}
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Promote As
                                    </Form.Label>
                                    <div className="d-flex gap-4">
                                        <Form.Check
                                            type="checkbox"
                                            id="trending"
                                            name="trending"
                                            label="Trending"
                                            checked={formData.promotions.trending}
                                            onChange={handleCheckboxChange}
                                        />
                                        <Form.Check
                                            type="checkbox"
                                            id="byGuruji"
                                            name="byGuruji"
                                            label="By Guruji"
                                            checked={formData.promotions.byGuruji}
                                            onChange={handleCheckboxChange}
                                        />
                                    </div>
                                </Form.Group>
                            </div>
                            <div className="col-6 mt-4">
                                {/* Subscription Type */}
                                <Form.Group>
                                    <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                        Subscription Type <span className="text-danger">*</span>
                                    </Form.Label>
                                    <div className="d-flex gap-4">
                                        <Form.Check
                                            type="radio"
                                            id="free"
                                            name="subscriptionType"
                                            value="FREE"
                                            label="Free"
                                            checked={true}
                                            disabled={false}
                                        />
                                        <Form.Check
                                            type="radio"
                                            id="paid"
                                            name="subscriptionType"
                                            value="PAID"
                                            label="Paid"
                                            checked={false}
                                            disabled={true}
                                        />
                                    </div>
                                </Form.Group>
                            </div>
                        </div>

                        {/* Is this content part of Explore or a Course? */}
                        <div className="mt-4">
                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                Is this Artifact, part of a Course?
                            </Form.Label>
                            <div className="d-flex gap-4">
                                <Form.Check
                                    type="checkbox"
                                    id="course"
                                    name="is_a_part_of_course"
                                    label="Yes"
                                    checked={formData.is_a_part_of_course}
                                    onChange={handleContentTypeChange}
                                />
                                <Form.Check
                                    type="checkbox"
                                    id="explore"
                                    name="is_a_part_of_explore"
                                    label="No"
                                    checked={formData.is_a_part_of_explore}
                                    onChange={handleContentTypeChange}
                                />

                            </div>
                        </div>

                        {/* Live Text (Mantra/Stotra) section */}
                        {formData.artifactType === 'audio or orals' &&
                        // && formData.category === 'MANTRAS_CHANTS' && 
                        (
                            <div className="mt-4">
                                <Form.Group>
                                    <div className="d-flex align-items-center mb-2">
                                        <Form.Check
                                            type="checkbox"
                                            id="hasLyrics"
                                            label="Live Text (Mantra/Stotra)"
                                            checked={hasLyrics}
                                            onChange={(e) => setHasLyrics(e.target.checked)}
                                            className="me-3"
                                        />
                                    </div>
                                    {hasLyrics && (
                                        <>
                                            <Form.Label className="mb-2" style={{ color: '#4A5568', fontWeight: '500' }}>
                                                Lyrics JSON
                                            </Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                placeholder='{"lines": [{"time": 0, "text": "First line"}, {"time": 3.5, "text": "Second line"}]}'
                                                value={files.lyricsData ? JSON.stringify(files.lyricsData, null, 2) : ''}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (!value.trim()) {
                                                        setFiles(prev => ({
                                                            ...prev,
                                                            lyricsData: null
                                                        }));
                                                        return;
                                                    }
                                                    try {
                                                        const parsed = JSON.parse(value);
                                                        if (!parsed.lines || !Array.isArray(parsed.lines)) {
                                                            toast.error("Invalid format. Expected {lines: [{time: number, text: string}]}");
                                                            return;
                                                        }
                                                        setFiles(prev => ({
                                                            ...prev,
                                                            lyricsData: parsed
                                                        }));
                                                    } catch (error) {
                                                        // Don't show error while typing
                                                    }
                                                }}
                                                onBlur={(e) => {
                                                    // Validate on blur
                                                    const value = e.target.value;
                                                    if (value.trim() && value !== '') {
                                                        try {
                                                            JSON.parse(value);
                                                        } catch (error) {
                                                            toast.error("Invalid JSON format");
                                                        }
                                                    }
                                                }}
                                                style={{
                                                    height: '150px',
                                                    fontSize: '12px',
                                                    fontFamily: 'monospace',
                                                    resize: 'vertical'
                                                }}
                                            />
                                            <Form.Text className="text-muted" style={{ fontSize: '10px' }}>
                                                Enter lyrics in JSON format with time in seconds
                                            </Form.Text>
                                        </>
                                    )}
                                </Form.Group>
                            </div>
                        )}

                        {/* Insights Area */}
                        <div className="mt-5">
                            <h6 className="text-primary mb-4" style={{ fontSize: '16px', color: '#6366F1' }}>Insights Area</h6>
                            <div className="d-flex align-items-center gap-4" style={{ background: "#F8FAFC", width: '670px', height: '150px', padding: '0 12px', borderRadius: '8px' }}>
                                <div style={{
                                    background: 'white',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    width: '200px',
                                    height: '125px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <p className="mb-1 text-muted text-center" style={{ fontSize: '14px' }}>No. of Clicks</p>
                                    <h5 className="mb-0 text-center" style={{ fontSize: '20px', fontWeight: '500' }}>-</h5>
                                </div>
                                <div style={{
                                    background: 'white',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    width: '200px',
                                    height: '125px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <p className="mb-1 text-muted text-center" style={{ fontSize: '14px' }}>No. of Views/Eyeballs</p>
                                    <h5 className="mb-0 text-center" style={{ fontSize: '20px', fontWeight: '500' }}>-</h5>
                                </div>
                                <div style={{
                                    background: 'white',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    width: '200px',
                                    height: '125px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <p className="mb-1 text-muted text-center" style={{ fontSize: '14px' }}>Avg. Time Spent</p>
                                    <h5 className="mb-0 text-center" style={{ fontSize: '20px', fontWeight: '500' }}>-</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>

                {/* Preview Modal */}
                <Modal
                    show={showPreview}
                    onHide={() => setShowPreview(false)}
                    size="lg"
                    centered
                    className="preview-modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Mobile Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: 0, display: 'flex', justifyContent: 'center', backgroundColor: '#f5f5f5' }}>
                        <div style={{
                            width: '280px',
                            height: '580px',
                            backgroundColor: 'white',
                            margin: '20px',
                            borderRadius: '25px',
                            padding: '20px',
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                            border: '8px solid #2c3e50',
                            position: 'relative',
                            overflow: 'hidden',
                            boxSizing: 'border-box'
                        }}>
                            {/* Header */}
                            <div style={{
                                textAlign: 'center',
                                padding: '5px 0',
                                borderBottom: '1px solid #e0e0e0',
                                marginBottom: '20px'
                            }}>
                                <h4 style={{ color: '#333', margin: 0 }}>Literature</h4>
                            </div>

                            {/* Title */}
                            <div style={{
                                textAlign: 'center',
                                marginBottom: '20px'
                            }}>
                                <h5 style={{ color: '#333', margin: 0, fontWeight: '600', wordWrap: 'break-word', maxWidth: '100%' }}>
                                    {formData.title || 'Your Title Here'}
                                </h5>
                            </div>

                            {/* Content */}
                            <div style={{
                                height: '400px',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                boxSizing: 'border-box',
                                padding: '0 10px',
                                fontSize: '14px',
                                lineHeight: '1.6',
                                color: '#333',
                                msOverflowStyle: 'none',   // Hides scrollbar in IE/Edge
                                scrollbarWidth: 'none',    // Hides scrollbar in Firefox
                                '::-webkit-scrollbar': {   // Hides scrollbar in Chrome/Safari
                                    display: 'none'
                                }
                            }}>
                                {/* <div dangerouslySetInnerHTML={{ __html: htmlContent || '<p>Your content will appear here...</p>' }}
                                    style={{
                                        maxWidth: '100%',
                                        wordWrap: 'break-word',
                                        wordBreak: 'break-word',
                                        overflow: 'hidden'
                                    }}
                                /> */}
                                <div
                                    style={{
                                        maxWidth: '100%',
                                        wordWrap: 'break-word',
                                        wordBreak: 'break-word',
                                        overflow: 'hidden'
                                    }}
                                    className="preview-content"
                                >
                                    <div
                                        dangerouslySetInnerHTML={{ __html: processHtmlForPreview(contentByLanguage.en || htmlContent) }}
                                        style={{
                                            maxWidth: '100%',
                                            wordWrap: 'break-word',
                                            wordBreak: 'break-word',
                                            overflow: 'hidden'
                                        }}
                                        className="preview-content"
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </Modal.Body>

            <Modal.Footer className="border-top-1">
                <Button
                    variant="primary"
                    className="px-4 py-2 ms-auto"
                    style={{ backgroundColor: '#6366F1' }}
                    onClick={handleSubmit}
                    disabled={isSubmitting || isSubmitted}
                >
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateLearning;